<template>
  <Teleport to="body">
  <div v-if="isOpen" class="lead-detail-modal-overlay fixed inset-0 z-[9999] md:z-[10000] flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm" @click="closeModal">
    <div class="modal-panel lead-detail-modal-root bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-[min(96vw,1680px)] mx-4 max-h-[95vh] overflow-hidden border border-gray-200 dark:border-gray-700" @click.stop>
      <!-- Header Premium -->
      <div class="lead-detail-modal-header-wrap relative overflow-hidden">
        <div class="modal-surface-gradient absolute inset-0 bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 dark:from-gray-800 dark:via-gray-700 dark:to-gray-800"></div>
        <div class="modal-header relative flex items-center justify-between p-3 border-b border-gray-200 dark:border-gray-700">
          <div class="lead-detail-modal-header-title flex items-center space-x-4 min-w-0">
            <div class="w-4 h-4 rounded-full shadow-lg" :style="{ backgroundColor: formData.cor || '#3B82F6' }"></div>
            <div>
              <h2 class="text-xl font-bold text-gray-900 dark:text-white">{{ t('kanban.leadDetail.header.title') }}</h2>
              <p class="text-xs text-gray-600 dark:text-gray-400">{{ t('kanban.leadDetail.header.subtitle') }}</p>
            </div>
          </div>
          <div class="lead-detail-modal-header-actions flex items-center space-x-2 shrink-0">
            <!-- Indicador de Status de Salvamento -->
            <div class="lead-detail-modal-save-status flex items-center space-x-2 min-w-0">
              <!-- Salvando informações -->
              <Transition name="status-fade" mode="out-in">
                <div v-if="salvandoContato || salvandoNegocio || salvandoOrigem || salvandoCor || salvandoTags || salvandoAtribuicao" key="salvando" class="flex items-center space-x-1 px-2 py-1 bg-blue-100 dark:bg-blue-900/30 rounded-lg transition-all duration-300">
                  <svg class="w-4 h-4 text-blue-600 dark:text-blue-400 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                  </svg>
                  <span class="text-xs font-medium text-blue-600 dark:text-blue-400">
                    {{ salvandoContato ? t('kanban.leadDetail.saveStatus.savingContact') : salvandoNegocio ? t('kanban.leadDetail.saveStatus.savingBusiness') : salvandoOrigem ? t('kanban.leadDetail.saveStatus.savingOrigin') : salvandoCor ? t('kanban.leadDetail.saveStatus.savingColor') : salvandoTags ? t('kanban.leadDetail.saveStatus.savingTags') : t('kanban.leadDetail.saveStatus.savingAssignment') }}
                  </span>
                </div>
                
                <!-- Salvo -->
                <div v-else-if="salvoContato || salvoNegocio || salvoOrigem || salvoCor || salvoTags || salvoAtribuicao" key="salvo" class="flex items-center space-x-1 px-2 py-1 bg-green-100 dark:bg-green-900/30 rounded-lg transition-all duration-300">
                  <svg class="w-4 h-4 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                  <span class="text-xs font-medium text-green-600 dark:text-green-400">
                    {{ salvoContato ? t('kanban.leadDetail.saveStatus.savedContact') : salvoNegocio ? t('kanban.leadDetail.saveStatus.savedBusiness') : salvoOrigem ? t('kanban.leadDetail.saveStatus.savedOrigin') : salvoCor ? t('kanban.leadDetail.saveStatus.savedColor') : salvoTags ? t('kanban.leadDetail.saveStatus.savedTags') : t('kanban.leadDetail.saveStatus.savedAssignment') }}
                  </span>
                </div>
                
                <!-- Pronto para editar (estado padrão) -->
                <div v-else key="pronto" class="flex items-center space-x-1 px-2 py-1 bg-gray-100 dark:bg-gray-700 rounded-lg transition-all duration-300">
                  <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                  </svg>
                  <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{ t('kanban.leadDetail.saveStatus.ready') }}</span>
                </div>
              </Transition>
            </div>
            
            <!-- Botão Fechar -->
            <button
              type="button"
              class="lead-detail-modal-close-btn p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-all duration-200 shrink-0"
              :aria-label="t('kanban.leadDetail.header.close')"
              @click="closeModal"
            >
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>
        <div
          v-if="isMobileViewport && whatsAppConnected"
          class="lead-detail-mobile-wa-bar"
        >
          <button
            type="button"
            class="lead-detail-mobile-wa-btn"
            @click="openMobileWhatsApp"
          >
            <svg class="lead-detail-mobile-wa-btn__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
            </svg>
            <span class="lead-detail-mobile-wa-btn__label">{{ t('kanban.leadDetail.whatsapp.openChat') }}</span>
            <span v-if="formData.telefone" class="lead-detail-mobile-wa-btn__phone">{{ formatBrazilPhoneForDisplay(formData.telefone) }}</span>
          </button>
        </div>
      </div>

      <div class="lead-detail-modal-body flex flex-1 min-h-0 h-[calc(90vh-60px)]">
        <!-- Left Panel - Lead Details -->
        <div class="lead-detail-modal-column lead-detail-modal-column--form modal-panel-column min-w-0 overflow-y-auto p-3 border-r border-gray-200 dark:border-gray-700" :class="leftPanelWidthClass">
          <!-- Informações de Contato -->
          <div v-if="!planBlocked('contactInfo')" class="mb-4" :class="{ 'mb-4': minimizedCards.contactInfo }">
            <div class="flex items-center justify-between mb-3" :class="{ 'border-b border-dashed border-gray-300 dark:border-gray-500 pb-3': minimizedCards.contactInfo }">
              <div class="flex items-center space-x-3">
                <div class="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-md">
                  <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                  </svg>
                </div>
                <div>
                  <h3 class="text-xl font-bold text-gray-900 dark:text-white">{{ t('kanban.leadDetail.contact.title') }}</h3>
                  <p class="text-sm text-gray-500 dark:text-gray-400">{{ t('kanban.leadDetail.contact.subtitle') }}</p>
                </div>
              </div>
              <button @click="toggleCard('contactInfo')" class="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <svg class="w-4 h-4 text-gray-500 dark:text-gray-400 transition-transform duration-200" :class="{ 'rotate-180': minimizedCards.contactInfo }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
            </div>
            <div v-show="!minimizedCards.contactInfo" class="modal-surface bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700 relative">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="space-y-3">
                  <div>
                    <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">{{ t('kanban.leadDetail.contact.fullName') }}</label>
                    <input v-model="formData.nome" type="text" class="lead-detail-form-input-tema-clara w-full px-2.5 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-600 dark:text-white transition-all duration-200" required>
                  </div>
                  <div>
                    <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">{{ t('kanban.leadDetail.contact.whatsapp') }}</label>
                    <input v-model="formData.telefone" type="tel" class="lead-detail-form-input-tema-clara w-full px-2.5 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-600 dark:text-white transition-all duration-200" :placeholder="t('kanban.leadDetail.contact.whatsappPlaceholder')" @input="formatWhatsApp" @keyup="formatWhatsApp" @paste="formatWhatsApp" @blur="formatWhatsApp">
                  </div>
                  <div>
                    <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">{{ t('kanban.leadDetail.contact.email') }}</label>
                    <input v-model="formData.email" type="email" class="lead-detail-form-input-tema-clara w-full px-2.5 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-600 dark:text-white transition-all duration-200" :placeholder="t('kanban.leadDetail.contact.emailPlaceholder')">
                  </div>
                </div>
                <div class="space-y-3">
                  <div>
                    <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">{{ t('kanban.leadDetail.contact.role') }}</label>
                    <input v-model="formData.cargo" type="text" class="lead-detail-form-input-tema-clara w-full px-2.5 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-600 dark:text-white transition-all duration-200">
                  </div>
                  <div>
                    <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">{{ t('kanban.leadDetail.contact.company') }}</label>
                    <input v-model="formData.empresa" type="text" class="lead-detail-form-input-tema-clara w-full px-2.5 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-600 dark:text-white transition-all duration-200">
                  </div>
                  <div>
                    <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">{{ t('kanban.leadDetail.contact.cnpj') }}</label>
                    <input v-model="formData.cnpj" type="text" class="lead-detail-form-input-tema-clara w-full px-2.5 py-1.5 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-600 dark:text-white transition-all duration-200" :placeholder="t('kanban.leadDetail.contact.cnpjPlaceholder')" @input="formatCNPJ" @keyup="formatCNPJ" @paste="formatCNPJ" @blur="formatCNPJ">
                  </div>
                </div>
              </div>
            </div>
          </div>

            <!-- Informações do Negócio -->
          <div v-if="!planBlocked('businessInfo')" class="mb-4" :class="{ 'mb-4': minimizedCards.businessInfo }">
            <div class="flex items-center justify-between mb-3" :class="{ 'border-b border-dashed border-gray-300 dark:border-gray-500 pb-3': minimizedCards.businessInfo }">
              <div class="flex items-center space-x-3">
                <div class="w-10 h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-xl flex items-center justify-center shadow-md">
                  <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
                  </svg>
                </div>
                <div>
                  <h3 class="text-xl font-bold text-gray-900 dark:text-white">{{ t('kanban.leadDetail.business.title') }}</h3>
                  <p class="text-sm text-gray-500 dark:text-gray-400">{{ t('kanban.leadDetail.business.subtitle') }}</p>
                </div>
              </div>
              <button @click="toggleCard('businessInfo')" class="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <svg class="w-4 h-4 text-gray-500 dark:text-gray-400 transition-transform duration-200" :class="{ 'rotate-180': minimizedCards.businessInfo }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
            </div>
            <div v-show="!minimizedCards.businessInfo" class="modal-surface bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700 relative">
              <div class="space-y-4">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div class="rounded-xl border border-emerald-200/80 dark:border-emerald-800/50 bg-gradient-to-br from-emerald-50/90 to-white dark:from-emerald-950/30 dark:to-gray-800/80 p-4">
                    <label class="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-emerald-700 dark:text-emerald-300 mb-2">
                      <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                      </svg>
                      {{ t('kanban.leadDetail.business.potentialValue') }}
                    </label>
                    <div class="money-input-with-prefix">
                      <MoneyInputPrefix size="lg" />
                      <input
                        v-model="formData.valorEstimado"
                        type="text"
                        inputmode="decimal"
                        class="lead-detail-form-input-tema-clara w-full px-3 py-2 text-lg font-semibold border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500/40 focus:border-emerald-400 dark:bg-gray-600 dark:text-white transition-all duration-200"
                        :placeholder="t('kanban.leadDetail.business.amountPlaceholder')"
                        @input="formatCurrency"
                        @blur="formatCurrency"
                      >
                    </div>
                  </div>
                  <div class="rounded-xl border border-blue-200/80 dark:border-blue-800/50 bg-gradient-to-br from-blue-50/90 to-white dark:from-blue-950/30 dark:to-gray-800/80 p-4">
                    <label class="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-blue-700 dark:text-blue-300 mb-2">
                      <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                      </svg>
                      {{ t('kanban.leadDetail.business.probability') }}
                    </label>
                    <div class="flex items-center gap-3">
                      <input
                        v-model="formData.probabilidade"
                        type="text"
                        class="lead-detail-form-input-tema-clara flex-1 min-w-0 px-3 py-2 text-base font-semibold border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:border-blue-400 dark:bg-gray-600 dark:text-white transition-all duration-200"
                        :placeholder="t('kanban.leadDetail.business.percentPlaceholder')"
                        @input="formatPercentage"
                      >
                      <span class="shrink-0 inline-flex items-center justify-center min-w-[3.25rem] px-2.5 py-2 rounded-lg bg-blue-600 text-white text-sm font-bold tabular-nums shadow-sm">
                        {{ probabilidadeSlider }}%
                      </span>
                    </div>
                  </div>
                </div>
                <div class="w-full rounded-xl border border-gray-200 dark:border-gray-600 bg-gray-50/80 dark:bg-gray-900/40 p-4">
                  <div class="flex items-center justify-between gap-3 mb-3">
                    <p class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ t('kanban.leadDetail.business.quickAdjust') }}</p>
                    <span class="text-xs text-gray-500 dark:text-gray-400 tabular-nums">{{ t('kanban.leadDetail.business.range') }}</span>
                  </div>
                  <input
                    v-model.number="probabilidadeSlider"
                    type="range"
                    min="0"
                    max="100"
                    step="1"
                    class="lead-probabilidade-slider w-full h-2.5 rounded-full appearance-none cursor-pointer bg-gray-200 dark:bg-gray-700"
                    :aria-label="t('kanban.leadDetail.business.probabilityAria')"
                  >
                  <div class="mt-2 h-2 w-full rounded-full bg-gray-200 dark:bg-gray-700 overflow-hidden" aria-hidden="true">
                    <div class="h-full rounded-full transition-all duration-300 ease-out" :style="probabilidadeBarStyle" />
                  </div>
                  <div class="mt-2 flex items-center justify-between text-[11px] font-medium text-gray-500 dark:text-gray-400">
                    <span>{{ t('kanban.leadDetail.business.low') }}</span>
                    <span class="text-gray-700 dark:text-gray-200 tabular-nums">{{ t('kanban.leadDetail.business.chancePercent', { percent: probabilidadeSlider }) }}</span>
                    <span>{{ t('kanban.leadDetail.business.high') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Origem do Lead -->
          <div v-if="!planBlocked('origin')" class="mb-4" :class="{ 'mb-4': minimizedCards.origin }">
            <div class="flex items-center justify-between mb-3" :class="{ 'border-b border-dashed border-gray-300 dark:border-gray-500 pb-3': minimizedCards.origin }">
              <div class="flex items-center space-x-3">
                <div class="w-10 h-10 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center shadow-md">
                  <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l4-4z"></path>
                  </svg>
                </div>
                <div>
                  <h3 class="text-xl font-bold text-gray-900 dark:text-white">{{ t('kanban.leadDetail.origin.title') }}</h3>
                  <p class="text-sm text-gray-500 dark:text-gray-400">{{ t('kanban.leadDetail.origin.obtainSubtitle') }}</p>
                </div>
              </div>
              <button @click="toggleCard('origin')" class="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <svg class="w-4 h-4 text-gray-500 dark:text-gray-400 transition-transform duration-200" :class="{ 'rotate-180': minimizedCards.origin }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
            </div>
            <div v-show="!minimizedCards.origin" class="modal-surface bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700 relative">
              <LeadOriginSelector v-model="formData.origem" :origins="workspaceOrigens" />
            </div>
          </div>

          <!-- Cor do Lead -->
          <div v-if="!planBlocked('leadColor')" class="mb-4" :class="{ 'mb-4': minimizedCards.leadColor }">
              <div class="flex items-center justify-between mb-3" :class="{ 'border-b border-dashed border-gray-300 dark:border-gray-500 pb-3': minimizedCards.leadColor }">
                <div class="flex items-center space-x-3">
                  <div class="w-10 h-10 bg-gradient-to-br from-pink-500 to-rose-600 rounded-xl flex items-center justify-center shadow-md">
                    <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 class="text-xl font-bold text-gray-900 dark:text-white">{{ t('kanban.leadDetail.leadColor.title') }}</h3>
                    <p class="text-sm text-gray-500 dark:text-gray-400">{{ t('kanban.leadDetail.leadColor.subtitle') }}</p>
                  </div>
                </div>
                <button @click="toggleCard('leadColor')" class="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors">
                  <svg class="w-4 h-4 text-gray-500 dark:text-gray-400 transition-transform duration-200" :class="{ 'rotate-180': minimizedCards.leadColor }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </button>
              </div>
              <div v-show="!minimizedCards.leadColor" class="modal-surface bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700 relative">
                <ColorSelector v-model="formData.cor" />
                <!-- Separador discreto -->
                <div class="absolute bottom-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-gray-200 dark:via-gray-600 to-transparent"></div>
              </div>
          </div>

          <!-- Usuários Atribuídos -->
          <div v-if="!planBlocked('assignedUsers')" class="mb-4" :class="{ 'mb-4': minimizedCards.assignedUsers }">
              <div class="flex items-center justify-between mb-3" :class="{ 'border-b border-dashed border-gray-300 dark:border-gray-500 pb-3': minimizedCards.assignedUsers }">
                <div class="flex items-center space-x-3">
                  <div class="w-10 h-10 bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-md">
                    <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 class="text-xl font-bold text-gray-900 dark:text-white">{{ t('kanban.leadDetail.assignedUsers.title') }}</h3>
                    <p class="text-sm text-gray-500 dark:text-gray-400">{{ t('kanban.leadDetail.assignedUsers.subtitle') }}</p>
                  </div>
                </div>
                <button @click="toggleCard('assignedUsers')" class="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors">
                  <svg class="w-4 h-4 text-gray-500 dark:text-gray-400 transition-transform duration-200" :class="{ 'rotate-180': minimizedCards.assignedUsers }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                  </svg>
                </button>
              </div>
              <div v-show="!minimizedCards.assignedUsers" class="modal-surface bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700 relative">
                <div class="space-y-1">
                  <div v-for="user in (Array.isArray(formData.usuariosAtribuidos) ? formData.usuariosAtribuidos : [])" :key="user.id" class="flex items-center justify-between p-2 bg-white dark:bg-gray-600 rounded border border-gray-200 dark:border-gray-500 shadow-sm">
                    <div class="flex items-center space-x-2">
                      <div class="relative">
                        <!-- Foto do usuário ou iniciais -->
                        <img 
                          v-if="user.fotoPerfil" 
                          :src="user.fotoPerfil" 
                          :alt="user.nomeCompleto"
                          class="w-6 h-6 rounded-full object-cover"
                        />
                        <div 
                          v-else 
                          class="w-6 h-6 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-xs font-semibold"
                        >
                          {{ getInitials(user.nomeCompleto) }}
                        </div>
                        <div class="absolute -bottom-0.5 -right-0.5 w-2 h-2 bg-green-500 border border-white dark:border-gray-600 rounded-full"></div>
                      </div>
                      <div>
                        <p class="text-xs font-semibold text-gray-900 dark:text-white">{{ user.nomeCompleto }}</p>
                        <p class="text-xs text-gray-600 dark:text-gray-400">{{ user.email }}</p>
                      </div>
                    </div>
                    <button @click="removeUser(user.id)" class="p-1 text-red-500 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900 rounded transition-colors">
                      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                      </svg>
                    </button>
                  </div>
                  <button @click="showUserSelector = true" class="w-full p-2 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded text-gray-500 dark:text-gray-400 hover:border-blue-500 hover:text-blue-500 transition-all duration-200 hover:bg-blue-50 dark:hover:bg-blue-900">
                    <div class="flex items-center justify-center space-x-1">
                      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                      </svg>
                      <span class="text-xs font-medium">{{ t('kanban.leadDetail.assignedUsers.assignButton') }}</span>
                    </div>
                  </button>
                </div>
                <!-- Separador discreto -->
                <div class="absolute bottom-0 left-4 right-4 h-px bg-gradient-to-r from-transparent via-gray-200 dark:via-gray-600 to-transparent"></div>
              </div>
          </div>

          <!-- Agendamento -->
          <div v-if="!planBlocked('agendamento')" class="mb-4" :class="{ 'mb-4': minimizedCards.agendamento }">
            <div class="flex items-center justify-between mb-3" :class="{ 'border-b border-dashed border-gray-300 dark:border-gray-500 pb-3': minimizedCards.agendamento }">
              <div class="flex items-center space-x-3">
                <div class="w-10 h-10 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center shadow-md">
                  <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                </div>
                <div>
                  <h3 class="text-xl font-bold text-gray-900 dark:text-white">{{ t('kanban.leadDetail.schedule.title') }}</h3>
                  <p class="text-sm text-gray-500 dark:text-gray-400">{{ t('kanban.leadDetail.schedule.subtitle') }}</p>
                </div>
              </div>
              <button @click="toggleCard('agendamento')" class="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <svg class="w-4 h-4 text-gray-500 dark:text-gray-400 transition-transform duration-200" :class="{ 'rotate-180': minimizedCards.agendamento }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
            </div>
            <div v-show="!minimizedCards.agendamento" class="modal-surface bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-100 dark:border-gray-700 overflow-hidden">
              <!-- Botão de ação -->
              <div class="p-4 bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-700 dark:to-gray-600">
                <button @click="abrirModalAgendamento" class="w-full flex items-center justify-center space-x-2 px-6 py-3 bg-gradient-to-r from-purple-500 via-blue-500 to-indigo-600 text-white rounded-lg hover:from-purple-600 hover:via-blue-600 hover:to-indigo-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:scale-[1.02] font-semibold">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                  <span>{{ formData.agendamento ? t('kanban.leadDetail.schedule.rescheduleButton') : t('kanban.leadDetail.schedule.scheduleButton') }}</span>
                </button>
              </div>

              <!-- Conteúdo do agendamento -->
              <div class="p-4">
                <!-- Agendamento existente -->
                <div v-if="formData.agendamento" class="bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-blue-900/20 dark:via-indigo-900/20 dark:to-purple-900/20 rounded-lg p-3 border border-blue-200 dark:border-blue-700 relative overflow-hidden">
                  <!-- Decoração de fundo -->
                  <div class="absolute top-0 right-0 w-12 h-12 bg-gradient-to-br from-blue-400/20 to-purple-400/20 rounded-full -translate-y-6 translate-x-6"></div>
                  <div class="absolute bottom-0 left-0 w-8 h-8 bg-gradient-to-tr from-indigo-400/20 to-blue-400/20 rounded-full translate-y-4 -translate-x-4"></div>
                  
                  <div class="relative z-10">
                    <div class="flex items-center justify-between">
                      <div class="flex items-center space-x-3">
                        <div class="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center shadow-md">
                          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                          </svg>
                        </div>
                        <div>
                          <div class="text-xs font-semibold text-blue-900 dark:text-blue-100 uppercase tracking-wide">
                            {{ t('kanban.leadDetail.schedule.scheduledFor') }}
                          </div>
                          <div class="text-lg font-bold text-blue-800 dark:text-blue-200">
                            {{ formatDataBrasileira(formData.agendamento) }}
                          </div>
                          <div class="text-sm font-medium text-blue-600 dark:text-blue-300">
                            {{ formatAgendamentoHora(formData.agendamento) }}
                          </div>
                        </div>
                      </div>
                      
                      <button @click="removerAgendamento" class="w-7 h-7 bg-red-50 dark:bg-red-900/20 text-red-500 dark:text-red-400 rounded-md flex items-center justify-center hover:bg-red-100 dark:hover:bg-red-900/30 transition-all duration-200 shadow-sm hover:shadow-md" :title="t('kanban.leadDetail.schedule.remove')">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                        </svg>
                      </button>
                    </div>
                    
                    <div class="mt-3 flex items-center space-x-2">
                      <div class="w-2 h-2 bg-green-500 rounded-full"></div>
                      <div class="text-xs font-medium text-green-700 dark:text-green-300">
                        {{ t('kanban.leadDetail.schedule.scheduled') }}
                      </div>
                    </div>
                    
                    <!-- Motivo do Agendamento -->
                    <div v-if="formData.agendamento?.motivo" class="mt-3 p-2 bg-white/50 dark:bg-gray-800/50 rounded-lg border border-blue-200/50 dark:border-blue-700/50">
                      <div class="flex items-center space-x-2">
                        <div class="w-6 h-6 rounded-full flex items-center justify-center text-white text-xs font-medium"
                             :style="{ backgroundColor: getMotivoCor(formData.agendamento.motivo) }">
                          {{ getMotivoIcon(formData.agendamento.motivo) }}
                        </div>
                        <div>
                          <div class="text-xs font-semibold text-blue-900 dark:text-blue-100 uppercase tracking-wide">
                            {{ t('kanban.leadDetail.schedule.reason') }}
                          </div>
                          <div class="text-sm font-medium text-blue-800 dark:text-blue-200">
                            {{ formData.agendamento.motivo }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              
                <!-- Nenhum agendamento -->
                <div v-else class="text-center py-8">
                  <div class="w-16 h-16 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-md">
                    <svg class="w-8 h-8 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                    </svg>
                  </div>
                  <h4 class="text-base font-semibold text-gray-700 dark:text-gray-300 mb-2">{{ t('kanban.leadDetail.schedule.emptyTitle') }}</h4>
                  <p class="text-sm text-gray-500 dark:text-gray-400 max-w-xs mx-auto leading-relaxed">
                    {{ t('kanban.leadDetail.schedule.emptyHint') }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Tags -->
          <div v-if="!planBlocked('tags')" class="mb-4" :class="{ 'mb-4': minimizedCards.tags }">
            <div class="flex items-center justify-between mb-3" :class="{ 'border-b border-dashed border-gray-300 dark:border-gray-500 pb-3': minimizedCards.tags }">
              <div class="flex items-center space-x-3">
                <div class="w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center shadow-md">
                  <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
                  </svg>
                </div>
                <div>
                  <h3 class="text-xl font-bold text-gray-900 dark:text-white">{{ t('kanban.leadDetail.tags.title') }}</h3>
                  <p class="text-sm text-gray-500 dark:text-gray-400">{{ t('kanban.leadDetail.tags.subtitle') }}</p>
                </div>
              </div>
              <button @click="toggleCard('tags')" class="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <svg class="w-4 h-4 text-gray-500 dark:text-gray-400 transition-transform duration-200" :class="{ 'rotate-180': minimizedCards.tags }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
            </div>
            <div v-show="!minimizedCards.tags" class="modal-surface bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700 relative">
              <div class="space-y-3">
                <div v-for="category in workspaceTags" :key="category.id" class="space-y-2">
                  <h4 class="text-sm font-semibold text-gray-700 dark:text-gray-300 flex items-center space-x-2">
                    <span>{{ category.nome }}</span>
                    <span class="px-1.5 py-0.5 bg-gray-200 dark:bg-gray-600 text-xs rounded-full">{{ category.tags.length }}</span>
                  </h4>
                  <div class="flex flex-wrap gap-1.5">
                    <button 
                      v-for="tag in category.tags" 
                      :key="tag.id"
                      @click="toggleTag(tag.id)"
                      :class="[
                        'px-2 py-1 rounded text-xs font-medium transition-all duration-200 hover:scale-105 flex items-center space-x-1.5 border',
                        selectedTags.includes(tag.id) 
                          ? 'shadow-md border-transparent' 
                          : 'lead-detail-tag-unselected-tema-clara bg-white dark:bg-gray-600 hover:bg-gray-100 dark:hover:bg-gray-500 border-gray-200 dark:border-gray-500'
                      ]"
                      :style="selectedTags.includes(tag.id) ? { 
                        backgroundColor: tag.cor,
                        color: getContrastColor(tag.cor)
                      } : {}"
                    >
                      <!-- Emoji da tag -->
                      <span class="text-sm">{{ getTagIcon(tag.icone) }}</span>
                      <!-- Nome da tag -->
                      <span>{{ tag.nome }}</span>
                    </button>
                  </div>
                </div>
                
                <!-- Empty State -->
                <div v-if="workspaceTags.length === 0" class="text-center py-8">
                  <svg class="w-12 h-12 mx-auto text-gray-300 dark:text-gray-600 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"></path>
                  </svg>
                  <p class="text-gray-500 dark:text-gray-400">{{ t('kanban.leadDetail.tags.empty') }}</p>
                </div>
              </div>
            </div>
          </div>

          <LeadOrcamentosCard
            v-if="leadWorkspaceId && lead?.id"
            :lead-id="lead.id"
            :workspace-id="leadWorkspaceId"
            :whatsapp-connected="whatsAppConnected"
            :send-orcamento-whatsapp="sendLeadOrcamentoWhatsapp"
          />

          <!-- Anexos e Imagens -->
          <div v-if="!planBlocked('anexos')" class="mb-4">
            <div class="flex items-center justify-between mb-3" :class="{ 'border-b border-dashed border-gray-300 dark:border-gray-500 pb-3': minimizedCards.anexos }">
              <div class="flex items-center space-x-3">
                <div class="w-10 h-10 bg-gradient-to-br from-yellow-500 to-orange-600 rounded-xl flex items-center justify-center shadow-md">
                  <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                </div>
                <div>
                  <h3 class="text-xl font-bold text-gray-900 dark:text-white">{{ t('kanban.leadDetail.attachments.title') }}</h3>
                  <p class="text-sm text-gray-500 dark:text-gray-400">{{ t('kanban.leadDetail.attachments.subtitle') }}</p>
                </div>
              </div>
              <button @click="toggleCard('anexos')" class="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors">
                <svg class="w-4 h-4 text-gray-500 dark:text-gray-400 transition-transform duration-200" :class="{ 'rotate-180': minimizedCards.anexos }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </button>
            </div>
            <div v-show="!minimizedCards.anexos" class="modal-surface bg-white dark:bg-gray-800 rounded-xl p-4 shadow-sm border border-gray-100 dark:border-gray-700 relative">
              <AnexosSection 
                :leadId="lead?.id" 
                :icon-only-upload="true"
                @anexosUpdated="handleAnexosUpdated"
              />
            </div>
          </div>
        </div>

        <!-- Middle Panel - WhatsApp Chat (desktop; mobile abre em drawer) -->
        <WhatsAppChatPanel
          v-if="whatsAppConnected && !isMobileViewport"
          ref="waPanelRef"
          entity-type="lead"
          :entity-id="lead?.id"
          :workspace-id="workspaceStore.currentWorkspace?.id"
          :contact-name="formData.nome"
          :contact-phone="formData.telefone"
          :contact-lid="lead?.whatsappLid || ''"
          :active="isOpen && !!lead?.id"
          layout="column"
          show-chatbot
          :column-class="whatsAppColumnClass"
        />
        <!-- Chat interno (Backlog) -->
        <div v-if="!planBlocked('internalChat')" class="lead-detail-modal-column lead-detail-modal-column--chat modal-panel-column flex flex-col min-h-0 min-w-0 border-l border-gray-200 dark:border-gray-700 p-0 overflow-hidden" :class="internalChatColumnClass">
          <TaskChatPanel
            :lead-id="lead?.id || null"
          />
        </div>

      </div>
    </div>

    <UserSelectorModal
      :is-open="showUserSelector"
      :selected-users="Array.isArray(formData.usuariosAtribuidos) ? formData.usuariosAtribuidos.map(u => u.id) : []"
      :available-users="workspaceUsers"
      @close="showUserSelector = false"
      @confirm="handleUserSelection"
    />

    <!-- Schedule Modal -->
    <ScheduleModal 
      :is-open="showScheduleModal" 
      :lead="props.lead"
      :motivos-agendamento="workspaceMotivosAgendamento"
      @close="fecharModalAgendamento" 
      @scheduled="onLeadScheduled" 
    />

    <ClienteSideDrawer
      v-if="isMobileViewport && whatsAppConnected"
      :open="showMobileWhatsApp"
      :title="formData.nome || t('kanban.leadDetail.whatsapp.contactFallback')"
      :subtitle="formatBrazilPhoneForDisplay(formData.telefone) || t('kanban.leadDetail.whatsapp.noPhone')"
      wide
      :show-header="false"
      body-class="cliente-side-drawer-body--flush"
      panel-class="lead-detail-wa-drawer-panel"
      :aria-label="t('kanban.leadDetail.whatsapp.openChat')"
      @close="closeMobileWhatsApp"
    >
      <WhatsAppChatPanel
        ref="waPanelRef"
        entity-type="lead"
        :entity-id="lead?.id"
        :workspace-id="workspaceStore.currentWorkspace?.id"
        :contact-name="formData.nome"
        :contact-phone="formData.telefone"
        :contact-lid="lead?.whatsappLid || ''"
        :active="showMobileWhatsApp && isOpen && !!lead?.id"
        layout="tab"
        show-chatbot
        column-class="wa-drawer-chat"
        class="cliente-side-drawer-pane cliente-side-drawer-pane--fill lead-detail-wa-mobile-panel"
      />
    </ClienteSideDrawer>

  </div>
  </Teleport>
</template>

<script setup>
import { ref, computed, watch, nextTick, onMounted, onUnmounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { useWorkspaceStore } from '../stores/workspace'
import { useAuthStore } from '../stores/auth'
import UserSelectorModal from './UserSelectorModal.vue'
import LeadOriginSelector from './LeadOriginSelector.vue'
import ColorSelector from './ColorSelector.vue'
import ScheduleModal from './ScheduleModal.vue'
import AnexosSection from './AnexosSection.vue'
import LeadOrcamentosCard from './orcamento/LeadOrcamentosCard.vue'
import TaskChatPanel from './TaskChatPanel.vue'
import WhatsAppChatPanel from './WhatsAppChatPanel.vue'
import ClienteSideDrawer from './cliente/ClienteSideDrawer.vue'
import api from '../services/api'
import Swal from 'sweetalert2'
import {
  normalizeBrazilPhoneForStorage,
  formatBrazilPhoneForDisplay,
  maskBrazilPhoneInput,
  digitsOnly
} from '../utils/phoneBr'
import { usePlanSectionGate } from '@/composables/usePlanSectionGate'
import { CRM_LEAD_CARD_PLAN_KEYS } from '@/constants/modalPlanSections'
import MoneyInputPrefix from './MoneyInputPrefix.vue'
import { formatMoneyAmount } from '@/utils/format'

const { planBlocked, loadPlanForWorkspace } = usePlanSectionGate(CRM_LEAD_CARD_PLAN_KEYS)

const props = defineProps({
  isOpen: Boolean,
  lead: Object
})

const emit = defineEmits(['close', 'save', 'lead-updated', 'open-existing-lead'])

const { t, locale } = useI18n()
const dateLocale = computed(() => {
  if (locale.value === 'en') return 'en-US'
  if (locale.value === 'es') return 'es'
  return 'pt-BR'
})

const workspaceStore = useWorkspaceStore()
const waPanelRef = ref(null)
const authStore = useAuthStore()
const isMobileViewport = ref(false)
const showMobileWhatsApp = ref(false)

const updateMobileViewport = () => {
  if (typeof window === 'undefined') return
  isMobileViewport.value = window.matchMedia('(max-width: 767px)').matches
}

const openMobileWhatsApp = async () => {
  showMobileWhatsApp.value = true
  await nextTick()
  await waPanelRef.value?.refreshWhatsAppStatus?.()
  await waPanelRef.value?.loadChatHistory?.()
  await waPanelRef.value?.markAllRead?.()
}

const closeMobileWhatsApp = () => {
  showMobileWhatsApp.value = false
}

// Form data
const formData = ref({
  nome: '',
  telefone: '',
  email: '',
  cargo: '',
  empresa: '',
  cnpj: '',
  valorEstimado: '',
  probabilidade: 0,
  origem: '',
  usuariosAtribuidos: [],
  agendamento: null,
  anexos: [],
  cor: '#3B82F6'
})

const whatsAppStatus = ref('')
const whatsAppSocketOpen = ref(false)
const whatsAppConnected = computed(() => String(whatsAppStatus.value || '').toUpperCase() === 'CONNECTED')
const leftPanelWidthClass = computed(() => {
  return whatsAppConnected.value
    ? 'flex-[40_1_0%] min-w-0 w-0'
    : 'w-[min(520px,42%)] flex-[0_0_min(520px,42%)]'
})

const whatsAppColumnClass = computed(() => 'flex-[35_1_0%] min-w-0 w-0')

const internalChatColumnClass = computed(() => {
  return whatsAppConnected.value
    ? 'flex-[35_1_0%] min-w-0 w-0'
    : 'flex-1 min-w-[280px]'
})

const refreshWhatsAppStatus = async () => {
  const wid = workspaceStore.currentWorkspace?.id
  if (!wid) {
    whatsAppStatus.value = ''
    return
  }
  whatsAppSocketOpen.value = false
  try {
    const r = await api.get(`/whatsapp/workspace/${wid}`)
    whatsAppStatus.value = r.data?.status || ''
    if (whatsAppConnected.value) {
      const health = await api.get(`/whatsapp/workspace/${wid}/gateway-health`)
      whatsAppSocketOpen.value = health.data?.canSend === true
    }
  } catch (_) {
    whatsAppStatus.value = ''
    whatsAppSocketOpen.value = false
  }
}

async function sendLeadOrcamentoWhatsapp (orc) {
  if (!whatsAppConnected.value || !orc?.publicUrl) return false
  const panel = waPanelRef.value
  if (!panel?.sendTextMessage) return false

  const message = `${t('orcamentos.whatsappMessage')}\n${orc.publicUrl}`
  const textOk = await panel.sendTextMessage(message)
  if (!textOk) return false

  let html = orc.snapshotHtml
  const { patchOrcamentoHtmlMedia } = await import('@/utils/orcamentoUtils')
  if (html) {
    html = patchOrcamentoHtmlMedia(html, '')
  }
  if (!html && orc.publicToken) {
    try {
      const { default: publicApi } = await import('@/services/publicApi')
      const { data } = await publicApi.get(`/public/orcamentos/${orc.publicToken}`)
      html = data?.htmlContent || null
    } catch {
      html = null
    }
  }
  if (!html || !panel.sendDocumentFile) return textOk

  const { generateOrcamentoPdfFile } = await import('@/utils/orcamentoPdf')
  const file = await generateOrcamentoPdfFile(html, `${orc.numero || 'orcamento'}.pdf`)
  if (!file) return textOk

  await panel.sendDocumentFile(file, orc.numero || orc.titulo || '')
  return true
}

// UI state
const showUserSelector = ref(false)
const showScheduleModal = ref(false)
const showFileUpload = ref(false)

// IA Propostas
const iaConsiderations = ref('')
const iaLoading = ref(false)
const propostas = ref([])
const showHtmlModal = ref(false)
const htmlAtual = ref('')
let pollingInterval = null
const tempoGeracao = ref({}) // { [propostaId]: tempoEmSegundos }
let contadorIntervals = {}

const formatDateTime = (iso) => {
  if (!iso) {
    return t('kanban.leadDetail.dateUnavailable')
  }
  
  try {
    // Se for array de números [2025, 10, 11, 23, 51, 46]
    if (Array.isArray(iso)) {
      // Java LocalDateTime vem como array: [ano, mês, dia, hora, minuto, segundo]
      const [ano, mes, dia, hora, minuto, segundo] = iso
      const d = new Date(ano, mes - 1, dia, hora, minuto, segundo || 0)
      
      const diaStr = String(dia).padStart(2, '0')
      const mesStr = String(mes).padStart(2, '0')
      const horaStr = String(hora).padStart(2, '0')
      const minutoStr = String(minuto).padStart(2, '0')
      const segundoStr = String(segundo || 0).padStart(2, '0')
      
      return `${diaStr}/${mesStr}/${ano}, ${horaStr}:${minutoStr}:${segundoStr}`
    }
    
    // Se for string ISO
    let d = new Date(iso)
    
    if (isNaN(d.getTime()) && typeof iso === 'string') {
      d = new Date(iso.replace('Z', ''))
    }
    
    if (isNaN(d.getTime())) {
      return String(iso).substring(0, 19).replace('T', ' ')
    }
    
    return d.toLocaleString(dateLocale.value, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
  } catch (e) {
    console.error('❌ Erro ao formatar data:', e, iso)
    return String(iso)
  }
}

const carregarPropostas = async () => {
  try {
    if (!props.lead?.id) return
    
    // Adicionar timestamp para evitar cache do browser
    const { data } = await api.get(`/ai/lead/${props.lead.id}/propostas`, { params: { _t: Date.now() } })
    
    console.log('📥 [IA] Propostas recebidas do backend:', data)
    
    propostas.value = (Array.isArray(data) ? data : []).map(p => {
      console.log('📊 [IA] Proposta ID:', p.id, '| dataCriacao:', p.dataCriacao, '| dataUpdate:', p.dataUpdate, '| status:', p.status)
      return { ...p, htmlContent: p.htmlContent || null }
    })
    
    // Inicializar contadores de tempo para propostas PENDING que ainda não têm contador
    propostas.value.forEach(p => {
      if (p.status === 'PENDING' && !tempoGeracao.value[p.id]) {
        tempoGeracao.value[p.id] = 0
        iniciarContador(p.id)
      } else if (p.status !== 'PENDING' && contadorIntervals[p.id]) {
        // Parar contador se a proposta não está mais PENDING
        pararContador(p.id)
      }
    })
    
    // Se há propostas PENDING, iniciar polling automático
    const hasPending = propostas.value.some(p => p.status === 'PENDING')
    if (hasPending && !pollingInterval) {
      console.log('🔄 [IA] Iniciando polling automático - há propostas PENDING')
      startPolling()
    } else if (!hasPending && pollingInterval) {
      console.log('✅ [IA] Parando polling - todas as propostas foram processadas')
      stopPolling()
    }
  } catch (e) {
    console.warn('Erro ao carregar propostas IA:', e)
  }
}

const iniciarContador = (propostaId) => {
  if (contadorIntervals[propostaId]) return
  
  contadorIntervals[propostaId] = setInterval(() => {
    tempoGeracao.value[propostaId] = (tempoGeracao.value[propostaId] || 0) + 1
  }, 1000)
}

const pararContador = (propostaId) => {
  if (contadorIntervals[propostaId]) {
    clearInterval(contadorIntervals[propostaId])
    delete contadorIntervals[propostaId]
  }
}

const formatarTempo = (segundos) => {
  const mins = Math.floor(segundos / 60)
  const secs = segundos % 60
  return `${mins}:${secs.toString().padStart(2, '0')}`
}

const startPolling = () => {
  if (pollingInterval) return
  
  // Buscar atualizações a cada 3 segundos
  pollingInterval = setInterval(async () => {
    try {
      if (!props.lead?.id) {
        stopPolling()
        return
      }
      
      const { data } = await api.get(`/ai/lead/${props.lead.id}/propostas`, { params: { _t: Date.now() } })
      const novasPropostas = (Array.isArray(data) ? data : []).map(p => ({ ...p, htmlContent: p.htmlContent || null }))
      
      // Verificar se houve mudanças de PENDING para READY
      const antigasPending = propostas.value.filter(p => p.status === 'PENDING').map(p => p.id)
      const novasReady = novasPropostas.filter(p => p.status === 'READY' && antigasPending.includes(p.id))
      
      if (novasReady.length > 0) {
        console.log('🎉 [IA] Proposta(s) pronta(s):', novasReady.map(p => p.id).join(', '))
      }
      
      propostas.value = novasPropostas
      
      // Parar polling se não há mais PENDING
      const hasPending = novasPropostas.some(p => p.status === 'PENDING')
      if (!hasPending) {
        stopPolling()
      }
    } catch (e) {
      console.warn('Erro no polling de propostas:', e)
    }
  }, 3000) // 3 segundos
}

const stopPolling = () => {
  if (pollingInterval) {
    clearInterval(pollingInterval)
    pollingInterval = null
    console.log('⏹️ [IA] Polling parado')
  }
  
  // Parar todos os contadores de tempo
  Object.keys(contadorIntervals).forEach(id => {
    pararContador(parseInt(id))
  })
}

const abrirModalHtml = (p) => {
  if (!p?.htmlContent) {
    Swal.fire({ icon: 'info', title: t('kanban.leadDetail.swal.waitTitle'), text: t('kanban.leadDetail.swal.waitText'), confirmButtonColor: '#8b5cf6' })
    return
  }
  htmlAtual.value = estilizarHtml(p.htmlContent)
  showHtmlModal.value = true
}

  const estilizarHtml = (html) => {
    // Envelopa com um estilo básico para leitura
    return `
      <style>
        .proposta { font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, Arial, 'Apple Color Emoji','Segoe UI Emoji'; line-height: 1.6; }
        h1 { font-size: 1.6rem; margin: 0.75rem 0; color: #111827; }
        h2 { font-size: 1.25rem; margin: 0.75rem 0; color: #1f2937; }
        h3 { font-size: 1.05rem; margin: 0.5rem 0; color: #374151; }
        p { margin: 0.35rem 0; color: #374151; }
        .dark h1, .dark h2, .dark h3, .dark p { color: #e5e7eb; }
      </style>
      ${html}
    `
  }

const gerarPropostaIA = async () => {
  try {
    if (!props.lead?.id) return
    iaLoading.value = true
    const payload = { consideracoes: iaConsiderations.value || '' }
    const { data } = await api.post(`/ai/lead/${props.lead.id}/propostas`, payload)
    if (data?.id) {
      // Inicializar contador para a nova proposta
      tempoGeracao.value[data.id] = 0
      iniciarContador(data.id)
      
      await carregarPropostas()
      iaConsiderations.value = ''
      
      Swal.fire({
        icon: 'success',
        title: t('kanban.leadDetail.aiProposal.generatingTitle'),
        html: t('kanban.leadDetail.aiProposal.generatingHtml'),
        confirmButtonText: t('kanban.leadDetail.aiProposal.ok'),
        confirmButtonColor: '#8b5cf6',
        timer: 2000,
        timerProgressBar: true
      })
    }
  } catch (e) {
    console.error('Erro ao gerar proposta IA:', e)
    Swal.fire({
      icon: 'error',
      title: t('kanban.leadDetail.aiProposal.generateErrorTitle'),
      text: e?.response?.data?.error || t('kanban.leadDetail.aiProposal.generateErrorFallback'),
      confirmButtonText: 'Ok',
      confirmButtonColor: '#ef4444'
    })
  } finally {
    iaLoading.value = false
  }
}

const resolveDownloadUrl = (path) => {
  if (!path) return null
  if (path.startsWith('http')) return path
  // Se vier só o caminho relativo, prefixar com fileServerUrl (mesmo padrão dos anexos)
  return `${config.fileServerUrl}${path}`
}

const baixarProposta = (p) => {
  const url = resolveDownloadUrl(p.downloadUrl)
  if (url) {
    window.open(url, '_blank')
  }
}

// Estados de salvamento
const salvandoContato = ref(false)
const salvoContato = ref(false)
const salvandoNegocio = ref(false)
const salvoNegocio = ref(false)
const salvandoOrigem = ref(false)
const salvoOrigem = ref(false)
const salvandoCor = ref(false)
const salvoCor = ref(false)

const salvandoTags = ref(false)
const salvoTags = ref(false)
const salvandoAtribuicao = ref(false)
const salvoAtribuicao = ref(false)

// Usuários do workspace
const workspaceUsers = ref([])

const getDefaultMinimizedCards = () => ({
  contactInfo: false,
  businessInfo: false,
  origin: false,
  leadColor: false,
  assignedUsers: false,
  agendamento: false,
  tags: false,
  anexos: false
})

const getLeadModalWorkspaceId = () =>
  props.lead?.workspaceId ?? workspaceStore.currentWorkspace?.id ?? null

const leadWorkspaceId = computed(() => getLeadModalWorkspaceId())

const getLeadModalMinimizedStorageKey = (workspaceId) =>
  workspaceId ? `leadModal_minimizedCards_ws_${workspaceId}` : null

const normalizeMinimizedCardsState = (parsed) => {
  const defaults = getDefaultMinimizedCards()
  const merged = { ...defaults, ...(parsed && typeof parsed === 'object' ? parsed : {}) }
  if (merged.colorUsers) {
    merged.leadColor = merged.leadColor || merged.colorUsers
    merged.assignedUsers = merged.assignedUsers || merged.colorUsers
  }
  delete merged.colorUsers
  delete merged.scheduling
  return { ...defaults, ...merged }
}

const loadMinimizedCardsState = (workspaceId) => {
  const defaults = getDefaultMinimizedCards()
  const key = getLeadModalMinimizedStorageKey(workspaceId)
  if (!key) return defaults
  try {
    const saved = localStorage.getItem(key)
    if (saved) {
      return normalizeMinimizedCardsState(JSON.parse(saved))
    }
  } catch (e) {
    console.error('Erro ao carregar estado das seções do lead:', e)
  }
  return defaults
}

const saveMinimizedCardsState = (workspaceId) => {
  const key = getLeadModalMinimizedStorageKey(workspaceId)
  if (!key) return
  try {
    localStorage.setItem(key, JSON.stringify(minimizedCards.value))
  } catch (e) {
    console.error('Erro ao salvar estado das seções do lead:', e)
  }
}

const minimizedCards = ref(loadMinimizedCardsState(getLeadModalWorkspaceId()))

watch(
  () => getLeadModalWorkspaceId(),
  (workspaceId, prevWorkspaceId) => {
    if (workspaceId === prevWorkspaceId) return
    minimizedCards.value = loadMinimizedCardsState(workspaceId)
  }
)

const toggleCard = (cardName) => {
  minimizedCards.value[cardName] = !minimizedCards.value[cardName]
  saveMinimizedCardsState(getLeadModalWorkspaceId())
}

// Tags e Origens
const selectedTags = ref([])
const workspaceTags = ref([])
const workspaceOrigens = ref([])
const workspaceMotivosAgendamento = ref([])

// Load workspace configurations
const loadWorkspaceConfigurations = async () => {
  try {
    console.log('🔍 Carregando configurações para workspace:', workspaceStore.currentWorkspace?.id)
    console.log('🔑 Token atual:', localStorage.getItem('token'))
    
    const response = await api.get(`/workspace-config/${workspaceStore.currentWorkspace?.id}/debug`)
    console.log('🔑 Token usado na requisição:', localStorage.getItem('token'))
    const config = response.data
    
    console.log('📊 Resposta completa do backend:', config)
    
    // Organizar tags por categoria
    workspaceTags.value = config.categorias || []
    
    // Organizar origens de lead
    workspaceOrigens.value = config.origensLead || []
    
    // Organizar motivos de agendamento
    workspaceMotivosAgendamento.value = config.motivosAgendamento || []
    
    console.log('✅ Configurações carregadas:', {
      categorias: config.categorias?.length || 0,
      origens: config.origensLead?.length || 0,
      motivos: config.motivosAgendamento?.length || 0,
      categoriasDetalhes: config.categorias,
      origensDetalhes: config.origensLead,
      motivosDetalhes: config.motivosAgendamento
    })
    
    // Log detalhado das tags para debug
    if (config.categorias) {
      config.categorias.forEach(categoria => {
        console.log(`📂 Categoria: ${categoria.nome}`)
        if (categoria.tags) {
          categoria.tags.forEach(tag => {
            console.log(`  🏷️ Tag: ${tag.nome} | Cor: ${tag.cor} | Ícone: ${tag.icone}`)
            console.log(`  📊 Tag completa:`, tag)
          })
        }
      })
    }
    
    // Log detalhado dos motivos de agendamento
    if (config.motivosAgendamento) {
      console.log('📅 Motivos de agendamento carregados:')
      config.motivosAgendamento.forEach(motivo => {
        console.log(`  📝 Motivo: ${motivo.nome}`)
        console.log(`  📊 Motivo completo:`, motivo)
      })
    } else {
      console.log('❌ Nenhum motivo de agendamento encontrado nas configurações')
    }
    
    console.log('📝 workspaceMotivosAgendamento após carregamento:', workspaceMotivosAgendamento.value)
    console.log('📝 Quantidade de motivos no workspaceMotivosAgendamento:', workspaceMotivosAgendamento.value.length)
  } catch (error) {
    console.error('❌ Erro ao carregar configurações do workspace:', error)
    console.log('🔄 Usando configurações de fallback...')
    
    // Fallback para configurações padrão
    workspaceTags.value = [
      {
        id: 1,
        nome: 'Geral',
        tags: [
          { id: 1, nome: 'Atenção', cor: '#F59E0B' },
          { id: 2, nome: 'Interessado em Preço', cor: '#8B5CF6' },
          { id: 3, nome: 'Pronto para Fechar', cor: '#10B981' },
          { id: 4, nome: 'Tomador de Decisão', cor: '#10B981' },
          { id: 5, nome: 'Urgente', cor: '#EF4444' }
        ]
      }
    ]
    workspaceOrigens.value = [
      { id: 1, origem: 'Facebook', icone: 'facebook' },
      { id: 2, origem: 'Instagram', icone: 'instagram' },
      { id: 3, origem: 'WhatsApp', icone: 'whatsapp' }
    ]
  }
}

const parseCurrencyBRL = (value) => {
  if (value == null || value === '') return 0
  if (typeof value === 'number' && Number.isFinite(value)) return value
  const cleaned = String(value).replace(/[^\d,]/g, '').replace(',', '.')
  const parsed = parseFloat(cleaned)
  return Number.isFinite(parsed) ? parsed : 0
}

const formatCurrencyBRLDisplay = (value) => {
  const amount = typeof value === 'number' ? value : parseCurrencyBRL(value)
  return formatMoneyAmount(Number.isFinite(amount) ? amount : 0, locale.value)
}

const formatCurrency = (event) => {
  const digits = String(event.target.value ?? '').replace(/\D/g, '')
  const formatted = digits === ''
    ? t('common.moneyZero')
    : formatCurrencyBRLDisplay(parseInt(digits, 10) / 100)

  event.target.value = formatted
  formData.value.valorEstimado = formatted
}

const parseProbabilidadePercent = (value) => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return Math.min(100, Math.max(0, Math.round(value)))
  }
  const digits = String(value ?? '').replace(/\D/g, '')
  return Math.min(100, Math.max(0, parseInt(digits, 10) || 0))
}

const probabilidadeSlider = computed({
  get: () => parseProbabilidadePercent(formData.value.probabilidade),
  set: (val) => {
    formData.value.probabilidade = Math.min(100, Math.max(0, Math.round(Number(val) || 0)))
  }
})

const probabilidadeBarStyle = computed(() => {
  const pct = probabilidadeSlider.value
  let background = 'linear-gradient(90deg, #ef4444, #f97316)'
  if (pct >= 80) background = 'linear-gradient(90deg, #22c55e, #10b981)'
  else if (pct >= 50) background = 'linear-gradient(90deg, #f59e0b, #eab308)'
  return { width: `${pct}%`, background }
})

// Watch for lead changes
watch(() => props.lead, (newLead) => {
  if (newLead) {
    console.log('🔄 Lead recebido para inicialização:', newLead)
    console.log('👥 Usuários atribuídos no lead:', newLead.usuariosAtribuidos)
    console.log('👥 Tipo de usuariosAtribuidos:', typeof newLead.usuariosAtribuidos, 'isArray:', Array.isArray(newLead.usuariosAtribuidos))
    console.log('👤 Usuário atribuído ID:', newLead.usuarioAtribuidoId)
    console.log('👤 Usuário atribuído Nome:', newLead.usuarioAtribuidoNome)
    
    // Parse do JSON de usuários atribuídos (vem como string do backend)
    let usuariosAtribuidosIds = []
    if (typeof newLead.usuariosAtribuidos === 'string' && newLead.usuariosAtribuidos) {
      try {
        usuariosAtribuidosIds = JSON.parse(newLead.usuariosAtribuidos)
        console.log('✅ Parse JSON bem-sucedido:', usuariosAtribuidosIds)
      } catch (error) {
        console.error('❌ Erro ao fazer parse de usuariosAtribuidos:', error)
        usuariosAtribuidosIds = []
      }
    } else if (Array.isArray(newLead.usuariosAtribuidos)) {
      usuariosAtribuidosIds = newLead.usuariosAtribuidos
    }
    
    // Buscar objetos completos dos usuários pelos IDs
    let usuariosAtribuidos = []
    if (usuariosAtribuidosIds.length > 0) {
      if (workspaceUsers.value.length > 0) {
        // workspaceUsers já carregado: buscar objetos completos
        usuariosAtribuidos = usuariosAtribuidosIds.map(id => {
          const user = workspaceUsers.value.find(u => u.id === id)
          if (user) {
            console.log('✅ Usuário encontrado:', user.nomeCompleto)
            return user
          } else {
            console.warn('⚠️ Usuário não encontrado para ID:', id)
            return {
              id,
              nomeCompleto: `Usuário ${id}`,
              email: `usuario${id}@exemplo.com`
            }
          }
        })
        console.log('👥 Usuários completos carregados:', usuariosAtribuidos)
      } else {
        // workspaceUsers ainda não carregado: criar objetos temporários para TODOS os IDs
        console.log('⏳ WorkspaceUsers ainda não carregado, criando objetos temporários para os IDs:', usuariosAtribuidosIds)
        usuariosAtribuidos = usuariosAtribuidosIds.map(id => {
          // Tentar usar os dados legados se o ID corresponder ao primeiro usuário
          if (id === newLead.usuarioAtribuidoId && newLead.usuarioAtribuidoNome) {
            return {
              id,
              nomeCompleto: newLead.usuarioAtribuidoNome,
              email: newLead.usuarioAtribuidoEmail || `usuario${id}@exemplo.com`
            }
          }
          // Caso contrário, criar objeto temporário genérico
          return {
            id,
            nomeCompleto: `Usuário ${id}`,
            email: `usuario${id}@exemplo.com`
          }
        })
        console.log('🔄 Objetos temporários criados para TODOS os usuários:', usuariosAtribuidos)
      }
    } else if (newLead.usuarioAtribuidoId) {
      // Fallback: se não tem usuariosAtribuidos mas tem usuarioAtribuidoId (campo legado)
      console.log('🔍 Sem usuariosAtribuidos, usando campo legado usuarioAtribuidoId:', newLead.usuarioAtribuidoId)
      
      if (workspaceUsers.value.length > 0) {
        const usuarioReal = workspaceUsers.value.find(u => u.id === newLead.usuarioAtribuidoId)
        if (usuarioReal) {
          usuariosAtribuidos = [usuarioReal]
          console.log('✅ Usuário real encontrado no workspaceUsers:', usuarioReal)
        } else {
          usuariosAtribuidos = [{
            id: newLead.usuarioAtribuidoId,
            nomeCompleto: newLead.usuarioAtribuidoNome || `Usuário ${newLead.usuarioAtribuidoId}`,
            email: newLead.usuarioAtribuidoEmail || `usuario${newLead.usuarioAtribuidoId}@exemplo.com`
          }]
        }
      } else {
        // WorkspaceUsers não carregado, criar temporário
        usuariosAtribuidos = [{
          id: newLead.usuarioAtribuidoId,
          nomeCompleto: newLead.usuarioAtribuidoNome || `Usuário ${newLead.usuarioAtribuidoId}`,
          email: newLead.usuarioAtribuidoEmail || `usuario${newLead.usuarioAtribuidoId}@exemplo.com`
        }]
        console.log('🔄 Objeto temporário criado com campo legado:', usuariosAtribuidos)
      }
    }
    
    formData.value = {
      nome: newLead.nome || '',
      telefone: formatBrazilPhoneForDisplay(newLead.telefone || ''),
      email: newLead.email || '',
      cargo: newLead.cargo || '',
      empresa: newLead.empresa || '',
      cnpj: newLead.cnpj || '',
      valorEstimado: formatCurrencyBRLDisplay(newLead.valorEstimado ?? 0),
      probabilidade: newLead.probabilidade || 0,
      origem: newLead.origem || '',
      usuariosAtribuidos: Array.isArray(usuariosAtribuidos) ? usuariosAtribuidos : [],
      agendamento: formData.value.agendamento || null, // Manter agendamento existente
      anexos: Array.isArray(newLead.anexos) ? newLead.anexos : [],
      cor: newLead.cor || '#3B82F6'
    }
    // Garantir que selectedTags seja sempre um array de IDs
    if (Array.isArray(newLead.tags)) {
      // Se tags é um array, verificar se são objetos ou IDs
      if (newLead.tags.length > 0) {
        if (typeof newLead.tags[0] === 'object' && newLead.tags[0].id) {
          // Array de objetos -> extrair apenas os IDs
          selectedTags.value = newLead.tags.map(tag => tag.id)
          console.log('🏷️ Tags convertidas de objetos para IDs:', selectedTags.value)
        } else {
          // Já é array de IDs
          selectedTags.value = newLead.tags
          console.log('🏷️ Tags já são IDs:', selectedTags.value)
        }
      } else {
        selectedTags.value = []
      }
    } else if (typeof newLead.tags === 'string' && newLead.tags) {
      // Se tags é string JSON, fazer parse
      try {
        const parsedTags = JSON.parse(newLead.tags)
        if (Array.isArray(parsedTags)) {
          // Filtrar valores null/undefined
          const validTags = parsedTags.filter(tag => tag != null)
          if (validTags.length > 0) {
            if (typeof validTags[0] === 'object' && validTags[0].id) {
              // Array de objetos -> extrair apenas os IDs
              selectedTags.value = validTags.map(tag => tag.id)
            } else {
              // Já é array de IDs
              selectedTags.value = validTags
            }
          } else {
            selectedTags.value = []
          }
        } else if (parsedTags != null) {
          selectedTags.value = [parsedTags]
        } else {
          selectedTags.value = []
        }
        console.log('🏷️ Tags parseadas do JSON:', selectedTags.value)
      } catch (error) {
        console.error('❌ Erro ao fazer parse das tags:', error)
        selectedTags.value = []
      }
    } else if (newLead.tags) {
      // Se tags não é array mas existe, pode ser um valor único (ID)
      selectedTags.value = [newLead.tags]
      console.log('🏷️ Tag única convertida para array:', selectedTags.value)
    } else {
      selectedTags.value = []
      console.log('🏷️ Nenhuma tag encontrada')
    }
    console.log('🏷️ selectedTags inicializado (final):', selectedTags.value)
  }
}, { immediate: true })

// Auto-save watchers
let saveTimeout = null
let tagsTimeout = null

// Flag global para evitar loops em TODOS os watchers
let isSaving = false

// Watch for contact information changes
watch([
  () => formData.value.nome,
  () => formData.value.telefone,
  () => formData.value.email,
  () => formData.value.cargo,
  () => formData.value.empresa,
  () => formData.value.cnpj
], () => {
  if (props.lead?.id && !isSaving) {
    debouncedSaveContactInfo()
  }
}, { deep: true })

// Watch for business information changes
watch([
  () => formData.value.valorEstimado,
  () => formData.value.probabilidade
], () => {
  if (props.lead?.id && !isSaving) {
    debouncedSaveBusinessInfo()
  }
}, { deep: true })

// Watch for origin changes
watch(() => formData.value.origem, () => {
  if (props.lead?.id && !isSaving) {
    debouncedSaveOrigin()
  }
}, { deep: true })

// Watch for color changes
watch(() => formData.value.cor, () => {
  if (props.lead?.id && !isSaving) {
    debouncedSaveColor()
  }
}, { deep: true })

// Watch for tags changes - observar o ref diretamente para detectar mudanças no array
watch(selectedTags, (newTags, oldTags) => {
  console.log('🏷️ Tags mudaram:', { antes: oldTags, depois: newTags })
  if (props.lead?.id && !isSaving) {
    console.log('🏷️ Disparando salvamento de tags...')
    debouncedSaveTags()
  }
}, { deep: true })

// Watch for user assignment changes
watch(() => formData.value.usuariosAtribuidos, () => {
  if (props.lead?.id && !isSaving) {
    debouncedSaveUserAssignment()
  }
}, { deep: true })

// Timeouts específicos para cada função
let userAssignmentTimeout = null

onBeforeUnmount(() => {
  if (saveTimeout) clearTimeout(saveTimeout)
  if (tagsTimeout) clearTimeout(tagsTimeout)
  if (userAssignmentTimeout) clearTimeout(userAssignmentTimeout)
})

// Debounced save functions
const debouncedSaveContactInfo = () => {
  if (saveTimeout) {
    clearTimeout(saveTimeout)
  }
  saveTimeout = setTimeout(() => {
    saveContactInfo()
  }, 1000) // 1 segundo de delay
}

const debouncedSaveBusinessInfo = () => {
  if (saveTimeout) {
    clearTimeout(saveTimeout)
  }
  saveTimeout = setTimeout(() => {
    saveBusinessInfo()
  }, 1000) // 1 segundo de delay
}

const debouncedSaveOrigin = () => {
  if (saveTimeout) {
    clearTimeout(saveTimeout)
  }
  saveTimeout = setTimeout(() => {
    saveOrigin()
  }, 1000) // 1 segundo de delay
}

const debouncedSaveColor = () => {
  if (saveTimeout) {
    clearTimeout(saveTimeout)
  }
  saveTimeout = setTimeout(() => {
    saveColor()
  }, 1000) // 1 segundo de delay
}

const debouncedSaveTags = () => {
  console.log('🏷️ debouncedSaveTags chamado, configurando timeout...')
  if (tagsTimeout) {
    clearTimeout(tagsTimeout)
  }
  tagsTimeout = setTimeout(() => {
    console.log('🏷️ Timeout expirado, chamando saveTags...')
    saveTags()
  }, 1000) // 1 segundo de delay
}

const debouncedSaveUserAssignment = () => {
  if (userAssignmentTimeout) {
    clearTimeout(userAssignmentTimeout)
  }
  userAssignmentTimeout = setTimeout(() => {
    saveUserAssignment()
  }, 1000) // 1 segundo de delay
}

// Auto-save function
const saveContactInfo = async () => {
  try {
    console.log('💾 Salvando informações de contato...', {
      id: props.lead?.id,
      nome: formData.value.nome,
      telefone: formData.value.telefone,
      email: formData.value.email,
      cargo: formData.value.cargo,
      empresa: formData.value.empresa,
      cnpj: formData.value.cnpj
    })
    
    isSaving = true // Desabilitar watchers
    salvandoContato.value = true
    salvoContato.value = false
    
    const contactData = {
      nome: formData.value.nome,
      telefone: normalizeBrazilPhoneForStorage(formData.value.telefone),
      email: formData.value.email,
      cargo: formData.value.cargo,
      empresa: formData.value.empresa,
      cnpj: formData.value.cnpj
    }
    
    const response = await api.put(`/leads/${props.lead.id}/contact`, contactData)
    console.log('✅ Informações de contato salvas com sucesso')
    
    // Atualizar o lead local com os dados retornados
    if (response.data) {
      Object.assign(props.lead, response.data)
      console.log('🔄 Lead atualizado localmente:', response.data)
    }
    
    // Emitir evento para notificar o componente pai
    emit('lead-updated', response.data)
    
    salvandoContato.value = false
    salvoContato.value = true
    
    // Reset do status após 2 segundos
    setTimeout(() => {
      salvoContato.value = false
      isSaving = false // Reabilitar watchers após feedback visual
    }, 2000)
    
  } catch (error) {
    console.error('❌ Erro ao salvar informações de contato:', error)
    salvandoContato.value = false
    salvoContato.value = false
    isSaving = false // Reabilitar watchers mesmo em erro

    const status = error?.response?.status
    const data = error?.response?.data
    if (status === 409 && (data?.code === 'WHATSAPP_DUPLICATE' || data?.existingLeadId)) {
      // Reverter telefone no form para não parecer salvo
      formData.value.telefone = formatBrazilPhoneForDisplay(props.lead?.telefone || '')
      const existingId = data.existingLeadId
      const existingNome = data.existingLeadNome || `#${existingId}`
      const unarchived = !!data.unarchived
      const result = await Swal.fire({
        icon: 'warning',
        title: t('kanban.leadDetail.duplicateWhatsapp.title'),
        html: unarchived
          ? t('kanban.leadDetail.duplicateWhatsapp.textUnarchived', { name: existingNome })
          : t('kanban.leadDetail.duplicateWhatsapp.textActive', { name: existingNome }),
        showCancelButton: true,
        confirmButtonText: t('kanban.leadDetail.duplicateWhatsapp.openExisting'),
        cancelButtonText: t('kanban.leadDetail.duplicateWhatsapp.dismiss'),
        confirmButtonColor: '#2563eb',
      })
      if (result.isConfirmed && existingId) {
        emit('open-existing-lead', { id: existingId, unarchived })
      } else if (unarchived) {
        emit('lead-updated', { id: existingId, unarchived: true })
      }
      return
    }
  }
}

// Auto-save function for business info
const saveBusinessInfo = async () => {
  try {
    console.log('💾 Salvando informações de negócio...', {
      id: props.lead?.id,
      valorEstimado: formData.value.valorEstimado,
      probabilidade: formData.value.probabilidade
    })
    
    isSaving = true // Desabilitar watchers
    salvandoNegocio.value = true
    salvoNegocio.value = false
    
    // Converter valor formatado para número
    const valorNumerico = parseCurrencyBRL(formData.value.valorEstimado)
    const probabilidadeNumerica = parseProbabilidadePercent(formData.value.probabilidade)
    
    console.log('💰 Valores convertidos:', {
      valorEstimado: valorNumerico,
      probabilidade: probabilidadeNumerica
    })
    
    const businessData = {
      valorEstimado: valorNumerico,
      probabilidade: probabilidadeNumerica
    }
    
    const response = await api.put(`/leads/${props.lead.id}/business`, businessData)
    console.log('✅ Informações de negócio salvas com sucesso')
    
    // Atualizar o lead local com os dados retornados
    if (response.data) {
      Object.assign(props.lead, response.data)
      console.log('🔄 Lead atualizado localmente:', response.data)
    }
    
    // Emitir evento para notificar o componente pai
    emit('lead-updated', response.data)
    
    salvandoNegocio.value = false
    salvoNegocio.value = true
    
    // Reset do status após 2 segundos
    setTimeout(() => {
      salvoNegocio.value = false
      isSaving = false // Reabilitar watchers
    }, 2000)
    
  } catch (error) {
    console.error('❌ Erro ao salvar informações de negócio:', error)
    salvandoNegocio.value = false
    salvoNegocio.value = false
    isSaving = false // Reabilitar watchers
  }
}

// Auto-save function for origin
const saveOrigin = async () => {
  try {
    console.log('💾 Salvando origem do lead...', {
      id: props.lead?.id,
      origem: formData.value.origem
    })
    
    isSaving = true // Desabilitar watchers
    salvandoOrigem.value = true
    salvoOrigem.value = false
    
    const originData = {
      origem: formData.value.origem
    }
    
    const response = await api.put(`/leads/${props.lead.id}/origin`, originData)
    console.log('✅ Origem do lead salva com sucesso')
    
    // Atualizar o lead local com os dados retornados
    if (response.data) {
      Object.assign(props.lead, response.data)
      console.log('🔄 Lead atualizado localmente:', response.data)
    }
    
    // Emitir evento para notificar o componente pai
    emit('lead-updated', response.data)
    
    salvandoOrigem.value = false
    salvoOrigem.value = true
    
    // Reset do status após 2 segundos
    setTimeout(() => {
      salvoOrigem.value = false
      isSaving = false // Reabilitar watchers
    }, 2000)
    
  } catch (error) {
    console.error('❌ Erro ao salvar origem do lead:', error)
    salvandoOrigem.value = false
    salvoOrigem.value = false
    isSaving = false // Reabilitar watchers
  }
}

// Auto-save function for color
const saveColor = async () => {
  try {
    console.log('💾 Salvando cor do lead...', {
      id: props.lead?.id,
      cor: formData.value.cor
    })
    
    isSaving = true // Desabilitar watchers
    salvandoCor.value = true
    salvoCor.value = false
    
    const colorData = {
      cor: formData.value.cor
    }
    
    const response = await api.put(`/leads/${props.lead.id}/color`, colorData)
    console.log('✅ Cor do lead salva com sucesso')
    
    // Atualizar o lead local com os dados retornados
    if (response.data) {
      Object.assign(props.lead, response.data)
      console.log('🔄 Lead atualizado localmente:', response.data)
    }
    
    // Emitir evento para notificar o componente pai
    emit('lead-updated', response.data)
    
    salvandoCor.value = false
    salvoCor.value = true
    
    // Reset do status após 2 segundos
    setTimeout(() => {
      salvoCor.value = false
      isSaving = false // Reabilitar watchers
    }, 2000)
    
  } catch (error) {
    console.error('❌ Erro ao salvar cor do lead:', error)
    salvandoCor.value = false
    salvoCor.value = false
    isSaving = false // Reabilitar watchers
  }
}

// Auto-save function for tags
const saveTags = async () => {
  try {
    // Converter Proxy para array simples de números
    const tagsArray = Array.isArray(selectedTags.value) 
      ? [...selectedTags.value].map(id => Number(id))
      : []
    
    console.log('💾 Salvando tags do lead...', {
      id: props.lead?.id,
      tags: tagsArray,
      tagsType: typeof tagsArray,
      isArray: Array.isArray(tagsArray)
    })
    
    isSaving = true // Desabilitar watchers
    salvandoTags.value = true
    salvoTags.value = false
    
    const tagsData = {
      tags: tagsArray
    }
    
    const response = await api.put(`/leads/${props.lead.id}/tags`, tagsData)
    console.log('✅ Tags do lead salvas com sucesso')
    
    // Atualizar o lead local com os dados retornados
    if (response.data) {
      Object.assign(props.lead, response.data)
      console.log('🔄 Lead atualizado localmente:', response.data)
    }
    
    // Emitir evento para notificar o componente pai
    emit('lead-updated', response.data)
    
    salvandoTags.value = false
    salvoTags.value = true
    
    // Reset do status após 2 segundos
    setTimeout(() => {
      salvoTags.value = false
      isSaving = false // Reabilitar watchers
    }, 2000)
    
  } catch (error) {
    console.error('❌ Erro ao salvar tags do lead:', error)
    salvandoTags.value = false
    salvoTags.value = false
    isSaving = false // Reabilitar watchers
  }
}

// Auto-save function for user assignment
const saveUserAssignment = async () => {
  // Evitar múltiplas chamadas simultâneas
  if (isSaving) {
    console.log('⏸️ Salvamento de atribuição já em andamento, aguardando...')
    return
  }
  
  try {
    console.log('💾 Salvando atribuição de usuários...', {
      id: props.lead?.id,
      usuariosAtribuidos: formData.value.usuariosAtribuidos
    })
    
    isSaving = true // Desabilitar watchers
    salvandoAtribuicao.value = true
    salvoAtribuicao.value = false
    
    // Enviar lista de IDs de todos os usuários atribuídos
    const usuariosIds = Array.isArray(formData.value.usuariosAtribuidos) 
      ? formData.value.usuariosAtribuidos.map(u => u.id)
      : []
    
    console.log('📤 Enviando IDs dos usuários:', usuariosIds)
    
    const assignmentData = {
      usuariosAtribuidosIds: usuariosIds
    }
    
    const response = await api.put(`/leads/${props.lead.id}/assignment`, assignmentData)
    
    console.log('✅ Resposta do backend:', response.data)
    
    // Atualizar o lead local com os dados retornados
    if (response.data) {
      Object.assign(props.lead, response.data)
      
      // NÃO atualizar formData aqui para evitar loop infinito
      // O formData já está correto pois foi o usuário que modificou
    }
    
    // Emitir evento para notificar o componente pai
    emit('lead-updated', response.data)
    
    salvandoAtribuicao.value = false
    salvoAtribuicao.value = true
    
    // Reset do status após 2 segundos
    setTimeout(() => {
      salvoAtribuicao.value = false
      isSaving = false // Reabilitar watchers
    }, 2000)
    
  } catch (error) {
    console.error('❌ Erro ao salvar atribuição de usuário:', error)
    salvandoAtribuicao.value = false
    salvoAtribuicao.value = false
    isSaving = false // Reabilitar watchers
  }
}

// Carregar usuários do workspace
const loadWorkspaceUsers = async () => {
  try {
    const token = localStorage.getItem('token')
    if (!token) {
      return
    }

    const workspaceId = workspaceStore.currentWorkspace?.id
    if (!workspaceId) {
      return
    }
    
    const response = await api.get(`/workspace-acesso/workspace/${workspaceId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    
    // Mapear dados da API para o formato esperado pelo frontend
    const usuariosApi = response.data || []
    workspaceUsers.value = usuariosApi.map(usuario => ({
      id: usuario.usuarioId,
      nomeCompleto: usuario.usuarioNome,
      email: usuario.usuarioEmail,
      fotoPerfil: usuario.usuarioFotoPerfil,
      roleWorkspace: usuario.roleWorkspace,
      ativo: usuario.ativo
    }))
    
    console.log('👥 Usuários do workspace carregados:', workspaceUsers.value.length)
    
  } catch (error) {
    console.error('❌ Erro ao carregar usuários do workspace:', error)
    workspaceUsers.value = []
  }
}

// Watch for modal open/close
watch(() => props.isOpen, async (isOpen, wasOpen) => {
  console.log('👀 [LeadDetailModal] Watch isOpen disparado - isOpen:', isOpen, 'wasOpen:', wasOpen, 'lead.id:', props.lead?.id)
  
  if (isOpen && !wasOpen && props.lead) {
    // Modal foi ABERTO (transição de false → true)
    console.log('🚀 [LeadDetailModal] Modal ABRINDO - Carregando dados...')
    const wsId = workspaceStore.currentWorkspace?.id
    if (wsId) await loadPlanForWorkspace(wsId)
    loadWorkspaceConfigurations()
    await loadWorkspaceUsers()
    console.log('👥 WorkspaceUsers carregados:', workspaceUsers.value)
    await refreshWhatsAppStatus()
    
    // Carregar agendamentos do lead
    console.log('📅 Carregando agendamentos do lead...')
    await carregarAgendamentosLead()
    console.log('📅 Agendamentos carregados')
    
  } else if (!isOpen && wasOpen) {
    showMobileWhatsApp.value = false
  } else {
    console.log('ℹ️ [LeadDetailModal] Nenhuma ação necessária neste watch')
  }
}, { immediate: true })

// Recarregar histórico ao trocar de lead
watch(() => props.lead?.id, async (id) => {
  if (props.isOpen && id) {
    await refreshWhatsAppStatus()
  }
})

// Watch for workspaceUsers changes to update user data with real objects
watch(() => workspaceUsers.value, (newUsers) => {
  console.log('👥 WorkspaceUsers mudou:', newUsers)
  
  // Atualizar TODOS os usuários atribuídos com dados reais, não apenas o primeiro
  if (props.lead && formData.value.usuariosAtribuidos.length > 0 && newUsers.length > 0 && !isSaving) {
    const usuariosAtualizados = formData.value.usuariosAtribuidos.map(usuarioAtual => {
      // Buscar usuário real com os mesmos dados
      const usuarioReal = newUsers.find(u => u.id === usuarioAtual.id)
      if (usuarioReal) {
        console.log('🔄 Atualizando dados do usuário:', usuarioAtual.nomeCompleto || usuarioAtual.id, '→', usuarioReal.nomeCompleto)
        return usuarioReal
      }
      // Se não encontrar, manter o atual
      return usuarioAtual
    })
    
    // Verificar se os IDs são os mesmos (não perdeu ninguém)
    const idsAtuais = formData.value.usuariosAtribuidos.map(u => u.id).sort().join(',')
    const idsNovos = usuariosAtualizados.map(u => u.id).sort().join(',')
    
    if (idsAtuais === idsNovos) {
      // Desabilitar salvamento automático temporariamente
      isSaving = true
      formData.value.usuariosAtribuidos = usuariosAtualizados
      console.log('✅ Usuários atribuídos atualizados com dados reais:', usuariosAtualizados.length, 'usuários')
      
      // Reabilitar salvamento após um pequeno delay
      setTimeout(() => {
        isSaving = false
      }, 100)
    }
  }
}, { deep: true })

// Debug: Log quando o componente é montado
console.log('🔧 LeadDetailModal montado com isOpen:', props.isOpen)

// Methods
const closeModal = async () => {
  console.log('🚪 [LeadDetailModal] closeModal chamado - Lead ID:', props.lead?.id)
  
  emit('close')
}

const saveLead = async () => {
  try {
    const leadData = {
      ...formData.value,
      tags: selectedTags.value
    }
    emit('save', leadData)
    closeModal()
  } catch (error) {
    console.error('Erro ao salvar lead:', error)
  }
}

const removeUser = (userId) => {
  if (Array.isArray(formData.value.usuariosAtribuidos)) {
    formData.value.usuariosAtribuidos = formData.value.usuariosAtribuidos.filter(u => u.id !== userId)
  }
}

// Funções de agendamento
const abrirModalAgendamento = () => {
  showScheduleModal.value = true
}

const fecharModalAgendamento = () => {
  console.log('🚪 Fechando modal de agendamento')
  console.trace('🔍 Stack trace do fecharModalAgendamento:')
  showScheduleModal.value = false
}

const onLeadScheduled = async (scheduleData) => {
  try {
    console.log('📅 Lead agendado:', scheduleData)
    // Recarregar os agendamentos do lead
    await carregarAgendamentosLead()
    console.log('🔄 Agendamentos recarregados')
    
    // 🔄 Emitir evento para atualizar o card no Kanban
    if (props.lead?.id && formData.value.agendamento) {
      const dataHora = formData.value.agendamento.dataHora.split(' ')
      
      const leadAtualizado = {
        ...props.lead,
        dataAgendamento: dataHora[0],
        horario: dataHora[1],
        motivo: formData.value.agendamento.motivo
      }
      
      console.log('🔄 Emitindo lead-updated com agendamento:', leadAtualizado)
      emit('lead-updated', leadAtualizado)
    }
    
    fecharModalAgendamento()
  } catch (error) {
    console.error('❌ ERRO em onLeadScheduled:', error)
    console.error('❌ Stack trace:', error.stack)
  }
}

// Função para carregar agendamentos do lead
const carregarAgendamentosLead = async () => {
  if (!props.lead?.id) {
    console.log('❌ Lead ID não encontrado para carregar agendamentos')
    return
  }
  
  console.log('📅 Carregando agendamentos para lead ID:', props.lead.id)
  
  try {
    const token = localStorage.getItem('token')
    const response = await api.get(`/agendamentos/lead/${props.lead.id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
    
    console.log('📅 Resposta dos agendamentos:', response.data)
    
    // Atualizar o formData com os agendamentos
    if (response.data && response.data.length > 0) {
      // Pegar o agendamento mais recente
      const ultimoAgendamento = response.data[0]
      formData.value.agendamento = {
        dataHora: `${ultimoAgendamento.dataAgendamento} ${ultimoAgendamento.horario}`,
        motivo: ultimoAgendamento.motivo || null
      }
      console.log('📅 Agendamento encontrado:', formData.value.agendamento)
      console.log('📅 Motivo do agendamento:', ultimoAgendamento.motivo)
    } else {
      formData.value.agendamento = null
      console.log('📅 Nenhum agendamento encontrado')
    }
  } catch (error) {
    console.error('❌ Erro ao carregar agendamentos:', error)
  }
}

// Função para remover agendamento
const removerAgendamento = async () => {
  if (!props.lead?.id) return
  
  try {
    const token = localStorage.getItem('token')
    
    // Buscar agendamentos do lead para obter os IDs
    const response = await api.get(`/agendamentos/lead/${props.lead.id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
    
    // Deletar todos os agendamentos encontrados
    if (response.data && response.data.length > 0) {
      for (const agendamento of response.data) {
        await api.delete(`/agendamentos/lead/agendamento/${agendamento.id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
      }
    }
    
    formData.value.agendamento = null
    console.log('✅ Agendamento removido com sucesso')
    
    // 🔄 Emitir evento para atualizar o card no Kanban (remover agendamento)
    const leadAtualizado = {
      ...props.lead,
      dataAgendamento: null,
      horario: null,
      motivo: null
    }
    
    console.log('🔄 Emitindo lead-updated sem agendamento:', leadAtualizado)
    emit('lead-updated', leadAtualizado)
    
  } catch (error) {
    console.error('❌ Erro ao remover agendamento:', error)
  }
}

// Funções para formatar agendamento
const formatAgendamentoData = (agendamento) => {
  console.log('🔍 formatAgendamentoData recebeu:', agendamento)
  
  if (!agendamento) return ''
  
  const [data, hora] = agendamento.split(' ')
  console.log('📅 Data extraída:', data, '⏰ Hora extraída:', hora)
  
  if (!data) return ''
  
  try {
    // Formato esperado: YYYY-MM-DD
    const [ano, mes, dia] = data.split('-')
    
    // Criar data com componentes locais (evita problema de timezone)
    const dataObj = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia))
    
    if (isNaN(dataObj.getTime())) {
      console.log('❌ Data inválida, retornando original')
      return data
    }
    
    // Formatar para português brasileiro
    const dataFormatada = dataObj.toLocaleDateString(dateLocale.value, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
    
    console.log('✅ Data formatada:', dataFormatada)
    return dataFormatada
  } catch (error) {
    console.error('❌ Erro ao formatar data:', error)
    return data
  }
}

const formatAgendamentoHora = (agendamento) => {
  if (!agendamento) return ''
  
  // Se é um objeto com dataHora e motivo
  if (typeof agendamento === 'object' && agendamento.dataHora) {
    const [data, hora] = agendamento.dataHora.split(' ')
    if (!hora) return ''
    
    try {
      const [horas, minutos] = hora.split(':')
      const horaFormatada = `${horas}:${minutos}`
      return horaFormatada
    } catch (error) {
      return hora
    }
  }
  
  // Se é uma string (formato antigo)
  const [data, hora] = agendamento.split(' ')
  if (!hora) return ''
  
  try {
    const [horas, minutos] = hora.split(':')
    const horaFormatada = `${horas}:${minutos}`
    return horaFormatada
  } catch (error) {
    return hora
  }
}

// Nova função simples para formato brasileiro
const formatDataBrasileira = (agendamento) => {
  if (!agendamento) return ''
  
  // Se é um objeto com dataHora e motivo
  if (typeof agendamento === 'object' && agendamento.dataHora) {
    const [data, hora] = agendamento.dataHora.split(' ')
    if (!data) return ''
    
    try {
      // Formato esperado: YYYY-MM-DD
      const [ano, mes, dia] = data.split('-')
      
      // Criar data com componentes locais (evita problema de timezone)
      const dataObj = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia))
      
      if (isNaN(dataObj.getTime())) return data
      
      return dataObj.toLocaleDateString(dateLocale.value, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    } catch (error) {
      console.error('❌ Erro ao formatar data brasileira:', error)
      return data
    }
  }
  
  // Se é uma string (formato antigo)
  const [data, hora] = agendamento.split(' ')
  if (!data) return ''
  
  try {
    // Formato esperado: YYYY-MM-DD
    const [ano, mes, dia] = data.split('-')
    
    // Criar data com componentes locais (evita problema de timezone)
    const dataObj = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia))
    
    if (isNaN(dataObj.getTime())) return data
    
    return dataObj.toLocaleDateString(dateLocale.value, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  } catch (error) {
    console.error('❌ Erro ao formatar data brasileira:', error)
    return data
  }
}

// Função para mapear ícones de motivos
const getMotivoIcon = (motivo) => {
  if (!motivo) return '📅'
  
  // Mapeamento de ícones de texto para emojis
  const iconMap = {
    'phone': '📞',
    'presentation': '📊',
    'handshake': '🤝',
    'done': '✅',
    'important': '⚠️',
    'low': '📉',
    'high': '📈',
    'project': '📁',
    'migration': '🔄',
    'approval': '👍',
    'web': '🌐',
    'linkedin': '💼',
    'google': '🔍',
    'calendar': '📅',
    'clock': '🕐',
    'check': '✅',
    'star': '⭐',
    'heart': '❤️',
    'fire': '🔥',
    'rocket': '🚀'
  }
  
  // Se já é um emoji, retorna como está
  if (motivo.match(/[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/u)) {
    return motivo
  }
  
  // Se é um texto, mapeia para emoji
  return iconMap[motivo.toLowerCase()] || '📅'
}

// Função para obter a cor do motivo
const getMotivoCor = (motivo) => {
  if (!motivo) return '#3B82F6'
  
  // Buscar o motivo nas configurações do workspace
  const motivoConfig = workspaceMotivosAgendamento.value.find(m => m.motivo === motivo)
  if (motivoConfig && motivoConfig.cor) {
    return motivoConfig.cor
  }
  
  // Cores padrão baseadas no tipo de motivo
  const colorMap = {
    'phone': '#3B82F6',
    'presentation': '#10B981',
    'handshake': '#F59E0B',
    'done': '#10B981',
    'important': '#EF4444',
    'low': '#6B7280',
    'high': '#EF4444',
    'project': '#8B5CF6',
    'migration': '#06B6D4',
    'approval': '#10B981',
    'web': '#3B82F6',
    'linkedin': '#0077B5',
    'google': '#4285F4',
    'calendar': '#3B82F6',
    'clock': '#6B7280',
    'check': '#10B981',
    'star': '#F59E0B',
    'heart': '#EF4444',
    'fire': '#F97316',
    'rocket': '#8B5CF6'
  }
  
  return colorMap[motivo.toLowerCase()] || '#3B82F6'
}

const handleUserSelection = async (selectedUserIds) => {
  console.log('🔄 handleUserSelection chamado com IDs:', selectedUserIds)
  console.log('👥 Usuários disponíveis:', workspaceUsers.value)
  
  // Buscar usuários completos pelos IDs selecionados
  const selectedUsers = selectedUserIds.map(id => {
    const user = workspaceUsers.value.find(u => u.id === id)
    if (user) {
      console.log('✅ Usuário encontrado:', user.nomeCompleto)
      return user
    } else {
      console.warn('⚠️ Usuário não encontrado para ID:', id)
      return {
        id,
        nomeCompleto: `Usuário ${id}`,
        email: `usuario${id}@exemplo.com`
      }
    }
  })
  
  console.log('👥 Usuários selecionados:', selectedUsers)
  formData.value.usuariosAtribuidos = selectedUsers
  showUserSelector.value = false
  
  // Salvar imediatamente no backend (como no TaskDetailModal)
  if (props.lead?.id) {
    await saveUserAssignment()
  }
}

const getInitials = (name) => {
  // Trata casos onde name é undefined, null ou vazio
  if (!name || typeof name !== 'string') {
    return '??'
  }
  
  return name
    .trim()
    .split(' ')
    .filter(word => word.length > 0)
    .map(word => word.charAt(0))
    .join('')
    .toUpperCase()
    .substring(0, 2) || '??'
}

const toggleTag = (tagId) => {
  console.log('🏷️ toggleTag chamado para tagId:', tagId)
  console.log('🏷️ selectedTags.value antes:', selectedTags.value, 'tipo:', typeof selectedTags.value)
  
  // Garantir que selectedTags.value é um array
  if (!Array.isArray(selectedTags.value)) {
    console.warn('⚠️ selectedTags.value não é um array! Corrigindo...')
    selectedTags.value = []
  }
  
  const index = selectedTags.value.indexOf(tagId)
  if (index > -1) {
    console.log('🏷️ Tag já selecionada, removendo...')
    selectedTags.value.splice(index, 1)
  } else {
    console.log('🏷️ Tag não selecionada, adicionando...')
    selectedTags.value.push(tagId)
  }
  console.log('🏷️ Tags selecionadas agora:', selectedTags.value)
}

// Importar utilitário centralizado de mapeamento de ícones
import { getTagIcon } from '@/utils/iconMapper'

// Função para calcular a cor de contraste baseada na cor de fundo
const getContrastColor = (hexColor) => {
  // Remove o # se presente
  const hex = hexColor.replace('#', '')
  
  // Converte para RGB
  const r = parseInt(hex.substr(0, 2), 16)
  const g = parseInt(hex.substr(2, 2), 16)
  const b = parseInt(hex.substr(4, 2), 16)
  
  // Calcula o brilho usando a fórmula de luminância
  const brightness = (r * 299 + g * 587 + b * 114) / 1000
  
  // Retorna branco para fundos escuros e preto para fundos claros
  return brightness > 128 ? '#000000' : '#FFFFFF'
}

// Função para formatar porcentagem
const formatPercentage = (event) => {
  let value = event.target.value

  // Remove tudo que não é número
  value = value.replace(/\D/g, '')

  // Limita a 100%
  const percentage = Math.min(parseInt(value) || 0, 100)

  // Atualiza o valor no formData
  formData.value.probabilidade = percentage

  // Atualiza o input com a formatação
  event.target.value = percentage + '%'
}

// Função para formatar WhatsApp
const formatWhatsApp = (event) => {
  const raw = event?.target?.value ?? ''
  if (!digitsOnly(raw)) {
    formData.value.telefone = ''
    if (event?.target) event.target.value = ''
    return
  }
  const formatted = maskBrazilPhoneInput(raw)
  formData.value.telefone = formatted
  if (event?.target) event.target.value = formatted
}

// Função para formatar CNPJ
const formatCNPJ = (event) => {
  let value = event.target.value
  
  // Remove tudo que não é número
  value = value.replace(/\D/g, '')
  
  if (value === '') {
    formData.value.cnpj = ''
    event.target.value = ''
    return
  }
  
  // Limita a 14 dígitos
  value = value.substring(0, 14)
  
  // Formata: XX.XXX.XXX/XXXX-XX
  let formatted = value
  if (value.length <= 2) {
    formatted = value
  } else if (value.length <= 5) {
    formatted = `${value.substring(0, 2)}.${value.substring(2)}`
  } else if (value.length <= 8) {
    formatted = `${value.substring(0, 2)}.${value.substring(2, 5)}.${value.substring(5)}`
  } else if (value.length <= 12) {
    formatted = `${value.substring(0, 2)}.${value.substring(2, 5)}.${value.substring(5, 8)}/${value.substring(8)}`
  } else {
    formatted = `${value.substring(0, 2)}.${value.substring(2, 5)}.${value.substring(5, 8)}/${value.substring(8, 12)}-${value.substring(12)}`
  }
  
  // Atualiza o valor no formData
  formData.value.cnpj = value
  
  // Atualiza o input com a formatação
  event.target.value = formatted
  
  // Força a atualização do v-model para manter a formatação
  nextTick(() => {
    formData.value.cnpj = formatted
  })
}

const removeAttachment = (attachmentId) => {
  formData.value.anexos = formData.value.anexos.filter(a => a.id !== attachmentId)
}

// Função para lidar com atualizações de anexos
const handleAnexosUpdated = async (anexosAtualizados) => {
  console.log('✅ Anexos atualizados no lead:', anexosAtualizados)
  
  try {
    // Buscar dados atualizados do lead do backend para garantir que temos a versão mais recente
    const response = await api.get(`/leads/${props.lead.id}`)
    console.log('📎 Lead recarregado do backend com anexos:', response.data)
    
    // Atualizar formData com os novos anexos
    if (response.data.anexos) {
      formData.value.anexos = Array.isArray(response.data.anexos) ? response.data.anexos : []
    }
    
    // Emitir evento para atualizar o card no Kanban em tempo real
    console.log('🔄 Emitindo lead-updated para atualizar Kanban')
    emit('lead-updated', response.data)
  } catch (error) {
    console.error('❌ Erro ao recarregar lead após atualização de anexos:', error)
  }
}

const formatDate = (date) => {
  if (!date) return ''
  return new Date(date).toLocaleDateString(dateLocale.value, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const formatTime = (date) => {
  return new Date(date).toLocaleTimeString(dateLocale.value, {
    hour: '2-digit',
    minute: '2-digit'
  })
}

const renderWhatsAppMessage = (text, sent) => {
  return formatWhatsAppMessageHtml(text, {
    linkClass: sent
      ? 'whatsapp-message-link whatsapp-message-link--sent'
      : 'whatsapp-message-link'
  })
}

const getYoutubePreviews = (text) => parseYoutubeLinksFromText(text)

const messageTextWithoutYoutube = (text) => {
  const previews = getYoutubePreviews(text)
  return textWithoutYoutubeUrls(text, previews)
}

const hasYoutubePreview = (message) => {
  if (message?.type && message.type !== 'TEXT') return false
  return getYoutubePreviews(message?.text).length > 0
}

const isMediaBubble = (message) => {
  const type = String(message?.type || 'TEXT').toUpperCase()
  return ['IMAGE', 'VIDEO', 'AUDIO', 'DOCUMENT'].includes(type)
}

const GENERATED_FILE_RE = /^\d{10,}_[a-z0-9]+\.[a-z0-9]+$/i

const fileExtension = (message) => {
  const name = message?.fileName || filenameFromMediaUrl(message?.mediaUrl) || ''
  const match = String(name).match(/\.([a-z0-9]+)$/i)
  return match ? match[1].toLowerCase() : 'arq'
}

const displayFileName = (message) => {
  const name = message?.fileName || filenameFromMediaUrl(message?.mediaUrl) || 'Documento'
  if (GENERATED_FILE_RE.test(String(name))) {
    const ext = fileExtension(message)
    return ext && ext !== 'arq' ? `Documento.${ext}` : 'Documento'
  }
  return name
}

const fileTypeLabel = (ext) => {
  const labels = {
    pdf: 'PDF',
    xlsx: 'Planilha Excel',
    xls: 'Planilha Excel',
    csv: 'Planilha CSV',
    doc: 'Documento Word',
    docx: 'Documento Word',
    ppt: 'Apresentação',
    pptx: 'Apresentação',
    zip: 'Arquivo compactado',
    rar: 'Arquivo compactado',
    '7z': 'Arquivo compactado',
    txt: 'Texto',
    png: 'Imagem',
    jpg: 'Imagem',
    jpeg: 'Imagem',
    gif: 'Imagem',
    mp4: 'Vídeo',
    mp3: 'Áudio',
    wav: 'Áudio'
  }
  return labels[ext] || (ext && ext !== 'arq' ? ext.toUpperCase() : 'Arquivo')
}

const fileIconClass = (message) => {
  const ext = fileExtension(message)
  if (ext === 'pdf') return 'wa-doc-icon--pdf'
  if (['xlsx', 'xls', 'csv'].includes(ext)) return 'wa-doc-icon--sheet'
  if (['doc', 'docx'].includes(ext)) return 'wa-doc-icon--doc'
  if (['zip', 'rar', '7z'].includes(ext)) return 'wa-doc-icon--archive'
  return 'wa-doc-icon--default'
}

// Normaliza timestamp vindo do backend (LocalDateTime ou epoch) evitando Invalid Date
const resolveTimestamp = (m) => {
  try {
    if (m && typeof m.timestampMessage === 'number' && m.timestampMessage > 0) {
      return new Date(m.timestampMessage)
    }
    if (m && m.dataCriacao) {
      // dataCriacao pode vir como '2025-10-11T14:58:29.225006' -> cortar nanos
      const raw = String(m.dataCriacao)
      const iso = raw.includes('T') ? raw.split('.')[0] : raw
      const dt = new Date(iso)
      if (!isNaN(dt.getTime())) return dt
    }
  } catch (e) {}
  return new Date()
}

const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}


onMounted(() => {
  updateMobileViewport()
  window.addEventListener('resize', updateMobileViewport)
  window.addEventListener('whatsapp.connected', () => refreshWhatsAppStatus())
  window.addEventListener('whatsapp.disconnected', () => refreshWhatsAppStatus())
})

// Limpar polling quando o componente é destruído
onUnmounted(() => {
  window.removeEventListener('resize', updateMobileViewport)
  console.log('🧹 [LeadDetailModal] Componente sendo destruído - limpando polling')
  stopPolling()
})
</script>

<style scoped>
/* Modal: manter mesmo fundo do sidebar no tema escuro */
:global(body.tema_escura) .modal-panel {
  background-color: var(--bg-secondary) !important;
}

:global(body.tema_escura) .modal-panel .modal-header,
:global(body.tema_escura) .modal-panel .modal-panel-column {
  background-color: var(--bg-secondary) !important;
}

:global(body.tema_escura) .modal-panel .modal-surface,
:global(body.tema_escura) .modal-panel .modal-surface-gradient {
  background: var(--bg-secondary) !important;
  border-color: var(--border-primary) !important;
}

:global(body.tema_escura) .modal-panel input,
:global(body.tema_escura) .modal-panel textarea,
:global(body.tema_escura) .modal-panel select {
  background-color: var(--bg-secondary) !important;
  border-color: var(--border-primary) !important;
  color: var(--text-primary) !important;
}

/* Chat WhatsApp — fundo (mensagens + composer) */
.wa-chat-scroll,
.wa-chat-composer {
  background-color: #e5ede5;
  background-image:
    radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.35) 0, transparent 45%),
    radial-gradient(circle at 80% 0%, rgba(255, 255, 255, 0.25) 0, transparent 40%),
    url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23c8d4c8' fill-opacity='0.35'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

:global(body.tema_escura) .wa-chat-scroll,
:global(body.tema_escura) .wa-chat-composer,
:global(.dark) .wa-chat-scroll,
:global(.dark) .wa-chat-composer {
  background-color: #0b141a;
  background-image:
    radial-gradient(circle at 15% 10%, rgba(32, 44, 51, 0.9) 0, transparent 50%),
    url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23182229' fill-opacity='0.55'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/svg%3E");
}

:global(body.tema_escura) .modal-panel .wa-chat-composer {
  background-color: #0b141a !important;
  background-image:
    radial-gradient(circle at 15% 10%, rgba(32, 44, 51, 0.9) 0, transparent 50%),
    url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23182229' fill-opacity='0.55'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/svg%3E") !important;
}

.wa-chat-composer {
  border-top: none;
  padding: 10px 12px 8px;
  flex-shrink: 0;
}

.wa-composer-input-wrap {
  margin-bottom: 8px;
}

.wa-composer-emoji-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  color: #8696a0;
  transition: color 0.15s ease, background 0.15s ease;
}

.wa-composer-emoji-btn:hover {
  color: #00a884;
  background: rgba(0, 168, 132, 0.12);
}

.wa-composer-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
}

.wa-composer-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(8px);
}

:global(body.tema_escura) .wa-composer-toolbar__actions,
:global(.dark) .wa-composer-toolbar__actions {
  background: rgba(32, 44, 51, 0.85);
  border-color: rgba(255, 255, 255, 0.08);
}

.wa-composer-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: none;
  background: transparent;
  color: #54656f;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, transform 0.12s ease;
}

.wa-composer-btn:hover {
  background: rgba(0, 0, 0, 0.06);
  color: #111b21;
}

.wa-composer-btn:active {
  transform: scale(0.94);
}

.wa-composer-trailing {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.wa-composer-end-attendance-wrap {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}

.wa-composer-end-attendance__tip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  color: #fff;
  background: #1f2937;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
  z-index: 20;
}

.wa-composer-end-attendance__tip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1f2937;
}

.wa-composer-end-attendance-wrap:hover .wa-composer-end-attendance__tip {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

:global(body.tema_escura) .wa-composer-end-attendance__tip,
:global(.dark) .wa-composer-end-attendance__tip {
  background: #374151;
  border-color: rgba(255, 255, 255, 0.1);
  color: #f9fafb;
}

:global(body.tema_escura) .wa-composer-end-attendance__tip::after,
:global(.dark) .wa-composer-end-attendance__tip::after {
  border-top-color: #374151;
}

.wa-composer-end-attendance {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid color-mix(in srgb, #f59e0b 50%, transparent);
  border-radius: 9999px;
  background: color-mix(in srgb, #f59e0b 10%, rgba(255, 255, 255, 0.9));
  color: #b45309;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.12s ease, border-color 0.15s ease;
}

.wa-composer-end-attendance:hover:not(:disabled) {
  background: color-mix(in srgb, #f59e0b 20%, rgba(255, 255, 255, 0.95));
  border-color: #f59e0b;
  transform: scale(1.04);
}

.wa-composer-end-attendance:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wa-composer-end-attendance__icon {
  width: 16px;
  height: 16px;
}

:global(body.tema_escura) .wa-composer-end-attendance,
:global(.dark) .wa-composer-end-attendance {
  background: color-mix(in srgb, #f59e0b 15%, rgba(32, 44, 51, 0.9));
  border-color: color-mix(in srgb, #fbbf24 40%, transparent);
  color: #fbbf24;
}

.wa-composer-btn--recording {
  background: #ef4444;
  color: #fff;
  animation: wa-rec-pulse 1.2s ease-in-out infinite;
}

.wa-composer-btn--recording:hover {
  background: #dc2626;
  color: #fff;
}

.wa-composer-btn__stop {
  width: 14px;
  height: 14px;
  border-radius: 3px;
  background: #fff;
}

.wa-composer-btn__icon {
  width: 18px;
  height: 18px;
}

:global(body.tema_escura) .wa-composer-btn,
:global(.dark) .wa-composer-btn {
  color: #aebac1;
}

:global(body.tema_escura) .wa-composer-btn:hover,
:global(.dark) .wa-composer-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #e9edef;
}

.wa-composer-send {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 9999px;
  background: linear-gradient(145deg, #00a884 0%, #008f72 100%);
  color: #fff;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 168, 132, 0.35);
  transition: transform 0.12s ease, box-shadow 0.15s ease, opacity 0.15s ease;
}

.wa-composer-send:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 168, 132, 0.45);
}

.wa-composer-send:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
  background: #94a3b8;
}

.wa-composer-recording {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 0 4px;
}

.wa-composer-recording__dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #ef4444;
  flex-shrink: 0;
  animation: wa-rec-pulse 1s ease-in-out infinite;
}

.wa-composer-recording__time {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #ef4444;
  font-variant-numeric: tabular-nums;
}

.wa-composer-recording__btn {
  border: none;
  border-radius: 9999px;
  padding: 6px 12px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, opacity 0.15s ease;
}

.wa-composer-recording__btn--ghost {
  background: rgba(0, 0, 0, 0.06);
  color: #54656f;
}

.wa-composer-recording__btn--send {
  background: #00a884;
  color: #fff;
}

.wa-composer-recording__btn--send:hover {
  background: #008f72;
}

:global(body.tema_escura) .wa-composer-recording__btn--ghost,
:global(.dark) .wa-composer-recording__btn--ghost {
  background: rgba(255, 255, 255, 0.1);
  color: #e9edef;
}

@keyframes wa-rec-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.45; }
}

.wa-composer-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 6px;
  padding: 0 2px;
  min-height: 16px;
}

.wa-composer-status__online {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.625rem;
  font-weight: 500;
  color: rgba(84, 101, 111, 0.75);
  letter-spacing: 0.01em;
}

.wa-composer-status__dot {
  width: 5px;
  height: 5px;
  border-radius: 9999px;
  background: #25d366;
  box-shadow: 0 0 0 2px rgba(37, 211, 102, 0.25);
}

.wa-composer-status__hints {
  font-size: 0.625rem;
  color: rgba(84, 101, 111, 0.55);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wa-composer-status__hints--rec {
  color: rgba(239, 68, 68, 0.75);
}

:global(body.tema_escura) .wa-composer-status__online,
:global(.dark) .wa-composer-status__online {
  color: rgba(174, 186, 193, 0.65);
}

:global(body.tema_escura) .wa-composer-status__hints,
:global(.dark) .wa-composer-status__hints {
  color: rgba(174, 186, 193, 0.45);
}

.wa-chat-scroll::-webkit-scrollbar {
  width: 6px;
}

.wa-chat-scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.wa-chat-empty__icon {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}

:global(body.tema_escura) .wa-chat-empty__icon,
:global(.dark) .wa-chat-empty__icon {
  background: rgba(32, 44, 51, 0.9);
}

.wa-bubble {
  position: relative;
  max-width: min(85%, 340px);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

.wa-bubble--in {
  background: #fff;
  color: #111b21;
  border-radius: 0 12px 12px 12px;
}

.wa-bubble--out {
  background: #d9fdd3;
  color: #111b21;
  border-radius: 12px 0 12px 12px;
}

:global(body.tema_escura) .wa-bubble--in,
:global(.dark) .wa-bubble--in {
  background: #202c33;
  color: #e9edef;
}

:global(body.tema_escura) .wa-bubble--out,
:global(.dark) .wa-bubble--out {
  background: #005c4b;
  color: #e9edef;
}

.wa-bubble--text {
  padding: 6px 8px 4px 10px;
}

.wa-bubble--media {
  padding: 4px;
  overflow: hidden;
}

.wa-bubble--link {
  padding: 4px 4px 2px;
  overflow: hidden;
  max-width: min(92%, 360px);
}

.wa-bubble__text {
  font-size: 0.875rem;
  line-height: 1.45;
  padding: 4px 6px 2px 8px;
  word-break: break-word;
}

.whatsapp-message-body {
  white-space: pre-line;
}

.wa-bubble__text--caption {
  padding-top: 6px;
}

.wa-bubble__footer {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 3px;
  padding: 2px 7px 5px;
  margin-top: -2px;
}

.wa-bubble__time {
  font-size: 0.6875rem;
  opacity: 0.65;
  line-height: 1;
}

.wa-bubble__tick {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 12px;
  margin-bottom: 1px;
  color: #53bdeb;
}

.wa-bubble__tick svg {
  display: block;
  width: 18px;
  height: 12px;
}

.wa-media__img {
  display: block;
  max-height: 280px;
  width: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.wa-media__video-wrap {
  border-radius: 8px;
  overflow: hidden;
  background: #000;
}

.wa-media__video {
  display: block;
  max-height: 280px;
  width: 100%;
}

.wa-audio__player {
  flex: 1;
  min-width: 0;
  height: 36px;
}

.wa-doc-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  min-width: 240px;
  max-width: 300px;
  border-radius: 10px;
  text-decoration: none;
  transition: background 0.15s ease, transform 0.1s ease;
}

.wa-doc-card:hover {
  transform: translateY(-1px);
}

.wa-doc-card--in {
  background: rgba(0, 0, 0, 0.04);
}

.wa-doc-card--in:hover {
  background: rgba(0, 0, 0, 0.07);
}

.wa-doc-card--out {
  background: rgba(255, 255, 255, 0.35);
}

.wa-doc-card--out:hover {
  background: rgba(255, 255, 255, 0.5);
}

:global(body.tema_escura) .wa-doc-card--in,
:global(.dark) .wa-doc-card--in {
  background: rgba(255, 255, 255, 0.06);
}

:global(body.tema_escura) .wa-doc-card--out,
:global(.dark) .wa-doc-card--out {
  background: rgba(0, 0, 0, 0.2);
}

.wa-doc-card__icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #fff;
}

.wa-doc-icon--pdf { background: linear-gradient(135deg, #e53935, #c62828); }
.wa-doc-icon--sheet { background: linear-gradient(135deg, #43a047, #2e7d32); }
.wa-doc-icon--doc { background: linear-gradient(135deg, #1e88e5, #1565c0); }
.wa-doc-icon--archive { background: linear-gradient(135deg, #fb8c00, #ef6c00); }
.wa-doc-icon--default { background: linear-gradient(135deg, #78909c, #546e7a); }

.wa-doc-card__name {
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wa-doc-card__meta {
  font-size: 0.75rem;
  opacity: 0.7;
  margin-top: 2px;
}

.wa-doc-card__action {
  flex-shrink: 0;
  opacity: 0.55;
}

/* Transições para indicadores de status */
.status-fade-enter-active,
.status-fade-leave-active {
  transition: all 0.3s ease;
}

.status-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.status-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

.composer-reveal-enter-active {
  transition: opacity 0.4s cubic-bezier(0.22, 1, 0.36, 1), transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.composer-reveal-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.composer-reveal-enter-from {
  opacity: 0;
  transform: translateX(16px) scale(0.97);
}

.composer-reveal-leave-to {
  opacity: 0;
  transform: translateX(10px) scale(0.98);
}

.lead-probabilidade-slider {
  accent-color: #2563eb;
}

.lead-probabilidade-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 9999px;
  background: #2563eb;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(37, 99, 235, 0.45);
  cursor: pointer;
}

.lead-probabilidade-slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 9999px;
  background: #2563eb;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(37, 99, 235, 0.45);
  cursor: pointer;
}

.wa-message-textarea {
  min-height: 49px;
  max-height: none;
  display: block;
  box-sizing: border-box;
  color: #111827;
}

:global(.dark) .wa-message-textarea,
:global(body.tema_escura) .modal-panel .wa-message-textarea {
  color: #fff;
}

/* Formatação de mensagens WhatsApp no chat */
.whatsapp-message-body :deep(strong) {
  font-weight: 700;
}

.whatsapp-message-body :deep(em) {
  font-style: italic;
}

.whatsapp-message-body :deep(s) {
  text-decoration: line-through;
}

.whatsapp-message-body :deep(.whatsapp-inline-code) {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.875em;
  padding: 0.1em 0.35em;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.08);
}

.whatsapp-message-body :deep(.whatsapp-code-block) {
  display: block;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.875em;
  padding: 0.35em 0.5em;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.08);
  white-space: pre-wrap;
  word-break: break-word;
}

.wa-bubble--out .whatsapp-message-body :deep(.whatsapp-inline-code),
.wa-bubble--out .whatsapp-message-body :deep(.whatsapp-code-block) {
  background: rgba(255, 255, 255, 0.2);
}

.whatsapp-message-body :deep(.whatsapp-message-link) {
  text-decoration: underline;
  word-break: break-all;
}

.whatsapp-message-body :deep(.whatsapp-message-link--sent) {
  color: #ecfdf5;
}

.whatsapp-message-body :deep(.whatsapp-message-link:not(.whatsapp-message-link--sent)) {
  color: #2563eb;
}

:global(body.tema_escura) .whatsapp-message-body :deep(.whatsapp-message-link:not(.whatsapp-message-link--sent)) {
  color: #93c5fd;
}
</style>

<!-- Tema claro: só elementos listados dentro deste modal -->
<style>
body.tema_clara .lead-detail-modal-root input.lead-detail-form-input-tema-clara,
html.light .lead-detail-modal-root input.lead-detail-form-input-tema-clara,
body.tema_clara .lead-detail-modal-root input[placeholder="#3B82F6"],
html.light .lead-detail-modal-root input[placeholder="#3B82F6"],
body.tema_clara .lead-detail-modal-root textarea[data-chat-input],
html.light .lead-detail-modal-root textarea[data-chat-input],
body.tema_clara .lead-detail-modal-root button.lead-detail-tag-unselected-tema-clara,
html.light .lead-detail-modal-root button.lead-detail-tag-unselected-tema-clara,
body.tema_clara .lead-detail-modal-root button.lead-detail-tag-unselected-tema-clara span,
html.light .lead-detail-modal-root button.lead-detail-tag-unselected-tema-clara span {
  color: #161616 !important;
  -webkit-text-fill-color: #161616 !important;
}

/* Tema escuro: bolhas enviadas do chat interno (nome + mensagem) */
body.tema_escura .lead-detail-modal-root .task-chat-bubble--out,
html.dark .lead-detail-modal-root .task-chat-bubble--out {
  background: #e7f5ff !important;
  color: #161616 !important;
}

body.tema_escura .lead-detail-modal-root .task-chat-bubble--out span.font-medium,
html.dark .lead-detail-modal-root .task-chat-bubble--out span.font-medium,
body.tema_escura .lead-detail-modal-root .task-chat-bubble--out .task-chat-bubble__text,
html.dark .lead-detail-modal-root .task-chat-bubble--out .task-chat-bubble__text {
  color: #161616 !important;
  -webkit-text-fill-color: #161616 !important;
}

/* Tema escuro: bolhas recebidas do chat interno (nome + mensagem) */
body.tema_escura .lead-detail-modal-root .task-chat-bubble--in,
html.dark .lead-detail-modal-root .task-chat-bubble--in {
  background: #fff !important;
  color: #1f2937 !important;
}

body.tema_escura .lead-detail-modal-root .task-chat-bubble--in span.font-medium,
html.dark .lead-detail-modal-root .task-chat-bubble--in span.font-medium {
  color: #374151 !important;
  -webkit-text-fill-color: #374151 !important;
}

body.tema_escura .lead-detail-modal-root .task-chat-bubble--in .task-chat-bubble__text,
html.dark .lead-detail-modal-root .task-chat-bubble--in .task-chat-bubble__text {
  color: #1f2937 !important;
  -webkit-text-fill-color: #1f2937 !important;
}

/* WhatsApp composer: mesmo visual do tema claro em ambos os temas */
body.tema_escura .lead-detail-modal-root .wa-message-textarea,
html.dark .lead-detail-modal-root .wa-message-textarea {
  background-color: rgba(255, 255, 255, 0.95) !important;
  border-color: rgba(0, 0, 0, 0.05) !important;
  color: #111827 !important;
}

body.tema_escura .lead-detail-modal-root .wa-message-textarea::placeholder,
html.dark .lead-detail-modal-root .wa-message-textarea::placeholder {
  color: #9ca3af !important;
}

/* —— Mobile (celular em pé): colunas empilhadas, largura total —— */
@media (max-width: 767px) {
  .lead-detail-modal-overlay {
    align-items: stretch !important;
    justify-content: flex-start !important;
  }

  .lead-detail-modal-root {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    border-radius: 0 !important;
    max-height: 100dvh !important;
    height: 100dvh !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .lead-detail-modal-root .lead-detail-modal-header-wrap {
    flex-shrink: 0;
    position: sticky;
    top: 0;
    z-index: 30;
    overflow: visible !important;
  }

  .lead-detail-modal-root .modal-header {
    flex-wrap: nowrap !important;
    gap: 8px;
    padding: 10px 12px !important;
    overflow: visible;
  }

  .lead-detail-modal-root .lead-detail-modal-header-title {
    min-width: 0;
    flex: 1 1 auto;
    overflow: hidden;
  }

  .lead-detail-modal-root .modal-header h2 {
    font-size: 1.125rem;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .lead-detail-modal-root .modal-header .text-xs {
    display: none;
  }

  .lead-detail-modal-root .lead-detail-modal-header-actions {
    flex: 0 0 auto;
    flex-shrink: 0;
    margin-left: 8px;
  }

  /* Status de salvamento ocupa muito espaço no mobile — some o texto, mantém só o fechar acessível */
  .lead-detail-modal-root .lead-detail-modal-save-status {
    display: none;
  }

  .lead-detail-modal-root .lead-detail-modal-close-btn {
    flex-shrink: 0;
    min-width: 40px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .lead-detail-modal-body {
    flex-direction: column !important;
    flex: 1 1 auto !important;
    min-height: 0 !important;
    height: auto !important;
    max-height: none !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch;
  }

  .lead-detail-modal-root .lead-detail-modal-column,
  .lead-detail-modal-root .modal-panel-column {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 auto !important;
    min-width: 0 !important;
    border-left: none !important;
    border-right: none !important;
    border-bottom: 1px solid var(--border-primary);
  }

  .lead-detail-modal-root .lead-detail-modal-column--form {
    overflow-y: visible !important;
    padding: 12px !important;
  }

  .lead-detail-modal-root .lead-detail-modal-column--chat {
    min-height: min(420px, 55dvh);
    border-bottom: none;
  }

  .lead-detail-mobile-wa-bar {
    position: relative;
    z-index: 2;
    padding: 0 12px 10px;
    border-bottom: 1px solid var(--border-primary);
    background: var(--bg-secondary);
  }

  .lead-detail-mobile-wa-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 10px 12px;
    border-radius: 10px;
    border: 1px solid rgba(16, 185, 129, 0.35);
    background: linear-gradient(135deg, rgba(16, 185, 129, 0.14), rgba(5, 150, 105, 0.08));
    color: #047857;
    font-size: 0.875rem;
    font-weight: 600;
    text-align: left;
  }

  .lead-detail-mobile-wa-btn__icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    color: #059669;
  }

  .lead-detail-mobile-wa-btn__label {
    flex: 1 1 auto;
    min-width: 0;
  }

  .lead-detail-mobile-wa-btn__phone {
    font-size: 0.75rem;
    font-weight: 500;
    opacity: 0.85;
    flex-shrink: 0;
  }

  :deep(.lead-detail-wa-drawer-panel) {
    width: 100vw !important;
    max-width: 100vw !important;
  }

  :deep(.lead-detail-wa-mobile-panel) {
    flex: 1 1 0;
    min-height: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  :deep(.cliente-side-drawer-body--flush .lead-detail-wa-mobile-panel) {
    flex: 1;
    min-height: 0;
    height: 100%;
  }

  :deep(.cliente-side-drawer-body--flush .lead-detail-wa-mobile-panel .wa-chat-scroll) {
    min-height: 0 !important;
    max-height: none !important;
    flex: 1 1 auto;
  }

  .lead-detail-modal-root .task-chat-plan-gate,
  .lead-detail-modal-root .task-chat-plan-body {
    min-height: 360px;
  }

  .lead-detail-modal-root .task-chat-messages {
    min-height: 180px;
  }

  .lead-detail-modal-root .mb-4 > .flex.items-center.justify-between.mb-3 {
    flex-wrap: wrap;
    gap: 8px;
  }

  .lead-detail-modal-root .mb-4 h3.text-xl {
    font-size: 1rem;
  }

  .lead-detail-modal-root .mb-4 .text-sm.text-gray-500 {
    font-size: 0.75rem;
  }

  .lead-detail-modal-root .w-10.h-10 {
    width: 2.25rem;
    height: 2.25rem;
  }
}
</style>
